/** @jsx m */

/** @const */ var HINT = {}
/** @const */ HINT.EMOTICONS_NOT_AFTER = 0
/** @const */ HINT.LITEDOWN_DECODE_HTML_ENTITIES = 0
/** @const */ HINT.PREG_HAS_PASSTHROUGH = false
/** @const */ HINT.RULE_AUTO_CLOSE = 1
/** @const */ HINT.RULE_AUTO_REOPEN = 1
/** @const */ HINT.RULE_BREAK_PARAGRAPH = 1
/** @const */ HINT.RULE_CREATE_PARAGRAPHS = 1
/** @const */ HINT.RULE_DISABLE_AUTO_BR = 1
/** @const */ HINT.RULE_ENABLE_AUTO_BR = 1
/** @const */ HINT.RULE_IGNORE_TAGS = 1
/** @const */ HINT.RULE_IGNORE_TEXT = 1
/** @const */ HINT.RULE_IGNORE_WHITESPACE = 1
/** @const */ HINT.RULE_IS_TRANSPARENT = 1
/** @const */ HINT.RULE_PREVENT_BR = 1
/** @const */ HINT.RULE_SUSPEND_AUTO_BR = 1
/** @const */ HINT.RULE_TRIM_FIRST_LINE = 1
/** @const */ HINT.attributeDefaultValue = 0
/** @const */ HINT.closeAncestor = 0
/** @const */ HINT.closeParent = 1
/** @const */ HINT.createChild = 1
/** @const */ HINT.fosterParent = 1
/** @const */ HINT.hash = 1
/** @const */ HINT.ignoreAttrs = 1
/** @const */ HINT.namespaces = 0
/** @const */ HINT.onRender = 1
/** @const */ HINT.onUpdate = 1
/** @const */ HINT.regexp = 1
/** @const */ HINT.regexpLimit = 1
/** @const */ HINT.requireAncestor = 0
/** @const */ var o553403F9 = [0]
/** @const */ var oC06C5BF5 = [8481]
/** @const */ var oF6AF222C = [32623]
/** @const */ var oD363F9C5 = [32551]
/** @const */ var o3C789569 = [15661]
/** @const */ var oB565876D = { flags: 2 }
/** @const */ var o939F1698 = { flags: 514 }
/** @const */ var oA80287CC = { flags: 3089 }
/** @const */ var o02D8DBB5 = { filterChain: [], required: !0 }
/** @const */ var o1BC3EAF4 = { filterChain: [], required: !1 }
/** @const */ var oD4869BFF = {
  B: 1,
  C: 1,
  COLOR: 1,
  EM: 1,
  EMAIL: 1,
  I: 1,
  S: 1,
  SIZE: 1,
  STRONG: 1,
  U: 1,
  URL: 1,
}
/** @const */ var oF3C6FA42 = { closeParent: oD4869BFF, flags: 3349 }
/** @const */ var oDF43256F = [
  /**
   * @param {*} attrValue
   * @param {string} attrName
   * @return {*}
   */
  function(attrValue, attrName) {
    return NumericFilter.filterUint(attrValue)
  },
]
/** @const */ var o118B31AC = /**
 * @param {!Tag} tag
 * @param {!Object} tagConfig
 * @return {*}
 */ function(tag, tagConfig) {
  return filterAttributes(tag, tagConfig, registeredVars, logger)
}
/** @const */ var o1B4F5B52 = [o118B31AC]
/** @const */ var o56E79363 = [
  /**
   * @param {*} attrValue
   * @param {string} attrName
   * @return {*}
   */
  function(attrValue, attrName) {
    return RegexpFilter.filter(attrValue, /^[-0-9A-Za-z_]+$/)
  },
]
/** @const */ var o6377B813 = /**
 * @param {*} attrValue
 * @param {string} attrName
 * @return {*}
 */ function(attrValue, attrName) {
  return RegexpFilter.filter(attrValue, /^[- +,.0-9A-Za-z_]+$/)
}
/** @const */ var o75AB9259 = { filterChain: oDF43256F, required: !1 }
/** @const */ var o6CB0A318 = { filterChain: oDF43256F, required: !0 }
/** @const */ var oE2346708 = { filterChain: o56E79363, required: !0 }
/** @const */ var oABCFC4A3 = { filterChain: [o6377B813], required: !0 }
/** @const */ var oF307D35C = {
  filterChain: [
    /**
     * @param {*} attrValue
     * @param {string} attrName
     * @return {*}
     */
    function(attrValue, attrName) {
      return UrlFilter.filter(attrValue, registeredVars['urlConfig'], logger)
    },
  ],
  required: !0,
}
/** @const */ var o1AF69066 = {
  closeParent: oD4869BFF,
  flags: 268,
  fosterParent: oD4869BFF,
}
/** @const */ var o5B6ED7AA = {
  allowed: oD363F9C5,
  attributes: {},
  bitNumber: 2,
  filterChain: o1B4F5B52,
  nestingLimit: 10,
  rules: oB565876D,
  tagLimit: 5000,
}
/** @const */ var o8F52476D = {
  allowed: oD363F9C5,
  attributes: {},
  bitNumber: 2,
  filterChain: o1B4F5B52,
  nestingLimit: 10,
  rules: { flags: 0 },
  tagLimit: 5000,
}
/** @const */ var oE13673F5 = {
  allowed: oD363F9C5,
  attributes: {},
  bitNumber: 3,
  filterChain: o1B4F5B52,
  nestingLimit: 10,
  rules: { closeParent: oD4869BFF, flags: 260, fosterParent: oD4869BFF },
  tagLimit: 5000,
}
/** @const */ var xsl = (
  '<xsl:stylesheet version="1.0" xmlns:xsl="http://www.w3.org/1999/XSL/Transform"><xsl:output method="html" encoding="utf-8" indent="no"/><xsl:param$mDISCUSSION_URL">http://enseignerleclimat.tech/d/</xsl:param><xsl:param$mPROFILE_URL">http://enseignerleclimat.tech/u/</xsl:param>$aB|DEL|EM|H1|H2|H3|H4|H5|H6|I|LI|S|STRONG|SUB|SUP|U|p"><xsl:element$m{translate(name(),\'BDEGHILMNOPRSTU\',\'bdeghilmnoprstu\')}">$b</xsl:element>$c$aC"><code>$b</code>$c$aCENTER"><div$itext-align:center">$b</div>$c$aCODE"><pre data-s9e-livepreview-hash="" data-s9e-livepreview-onupdate="if(typeof hljsLoader!==\'undefined\')hljsLoader.highlightBlocks(this)"><code><xsl:if$f@lang"><xsl:attribute$mclass">language-$d@lang"/></xsl:attribute></xsl:if>$b</code><script async="" crossorigin="anonymous" data-hljs-style="github-gist" data-s9e-livepreview-onrender="if(typeof hljsLoader!==\'undefined\')this.parentNode.removeChild(this)" integrity="sha384-PG1zopchh98J/8eUG/5ESEA+dE1Art6Ym1XKxLljmoOwlodOfUguCC/cydPWZSQ/" onload="hljsLoader.highlightBlocks(this.parentNode)" src="https://cdn.jsdelivr.net/gh/s9e/hljs-loader@1.0.8/loader.min.js"/></pre>$c$aCOLOR"><span$icolor:{@color}">$b</span>$c$aE"><xsl:choose><$g$f.=\':)\'">\ud83d\ude42</$g><$g$f.=\':D\'">\ud83d\ude03</$g><$g$f.=\':P\'">\ud83d\ude1b</$g><$g$f.=\':(\'">\ud83d\ude41</$g><$g$f.=\':|\'">\ud83d\ude10</$g><$g$f.=\';)\'">\ud83d\ude09</$g><$g$f.=&quot;:\'(&quot;">\ud83d\ude22</$g><$g$f.=\':O\'">\ud83d\ude2e</$g><$g$f.=\'&gt;:(\'">\ud83d\ude21</$g><xsl:otherwise>$d."/></xsl:otherwise></xsl:choose>$c$aEMAIL"><a href="mailto:{@email}">$b</a>$c$aESC">$b$c$aHR"><hr/>$c$aIMG"><img src="{@src}" title="{@title}" alt="{@alt}">$hheight|@width"/></img>$c$aISPOILER"><span$espoiler"$jstyle" onclick="removeAttribute(\'style\'); removeAttribute(\'class\')"$ibackground:#444;color:transparent">$b</span>$c$aLIST"><xsl:choose><$g$fnot(@type)"><ul>$b</ul></$g><$g$fstarts-with(@type,\'decimal\')or starts-with(@type,\'lower\')or starts-with(@type,\'upper\')"><ol$i$l>$hstart"/>$b</ol></$g><xsl:otherwise><ul$i$l>$b</ul></xsl:otherwise></xsl:choose>$c$aPOSTMENTION"><a href="{$DISC' +
  'USSION_URL}{@discussionid}/{@number}"$ePostMention" data-id="{@id}">$d@displayname"/></a>$c$aQUOTE"><blockquote><xsl:if$fnot(@author)"><xsl:attribute$mclass">uncited</xsl:attribute></xsl:if><div><xsl:if$f@author"><cite>$d@author"/> wrote:</cite></xsl:if>$b</div></blockquote>$c$aSIZE"><span$ifont-size:{@size}px">$b</span>$c$aSPOILER"><details$espoiler"$jopen">$b</details>$c$aUPL-FILE"><div$eButtonGroup"$k{@uuid}"><div$eButton hasIcon Button--icon Button--primary"><i$efas fa-download"/></div><div$eButton">$d@content"/></div><div$eButton">$d@size"/></div></div>$c$aUPL-IMAGE"><div$efof-download row"$k{@uuid}"><div$ecard"><div$ewrapper"$ibackground:url({@url}) center / cover no-repeat"><div$eheader"><ul$emenu-content"><li><div$efar fa-hdd"><span>$d@size"/></span></div></li></ul></div><div$edata"><div$econtent"><h4$etitle">$d@content"/></h4><div$eButton Button--primary Button-icon Button--block"><i$efas fa-download"/></div></div></div></div></div></div>$c$aUPL-IMAGE-PREVIEW"><img src="{@url}" title="{@base_name}"/>$c$aURL"><a href="{@url}" rel=" nofollow ugc">$htitle"/>$b</a>$c$aUSERMENTION"><a href="{$PROFILE_URL}{@username}"$eUserMention">@$d@displayname"/></a>$c$abr"><br/>$c$ae|i|s"/></xsl:stylesheet>'
).replace(/\$[a-m]/g, function(k) {
  return {
    $a: '<xsl:template match="',
    $b: '<xsl:apply-templates/>',
    $c: '</xsl:template>',
    $d: '<xsl:value-of select="',
    $e: ' class="',
    $f: ' test="',
    $g: 'xsl:when',
    $h: '<xsl:copy-of select="@',
    $i: ' style="',
    $j: ' data-s9e-livepreview-ignore-attrs="',
    $k: ' data-fof-upload-download-uuid="',
    $l: 'list-style-type:{@type}"',
    $m: ' name="',
  }[k]
})
/** @const */
var EmailFilter = {
  /**
   * @param  {*} attrValue
   * @return {*}
   */
  filter: function(attrValue) {
    return /^[-\w.+]+@[-\w.]+$/.test(attrValue) ? attrValue : false
  },
}
/** @const */
var FalseFilter = {
  /**
   * @param  {*} attrValue
   * @return {boolean}
   */
  filter: function(attrValue) {
    return false
  },
}
/** @const */
var HashmapFilter = {
  /**
   * @param  {*}        attrValue Original value
   * @param  {!Object}  map       Hash map
   * @param  {boolean} strict    Whether this map is strict (values with no match are invalid)
   * @return {*}                  Filtered value, or FALSE if invalid
   */
  filter: function(attrValue, map, strict) {
    if (attrValue in map) {
      return map[attrValue]
    }

    return strict ? false : attrValue
  },
}
/** @const */
var MapFilter = {
  /**
   * @param  {*} attrValue
   * @param  {!Array.<!Array>}  map
   * @return {*}
   */
  filter: function(attrValue, map) {
    var i = -1,
      cnt = map.length
    while (++i < cnt) {
      if (map[i][0].test(attrValue)) {
        return map[i][1]
      }
    }

    return attrValue
  },
}
/** @const */
var NetworkFilter = {
  /**
   * @param  {*} attrValue
   * @return {*}
   */
  filterIp: function(attrValue) {
    if (/^[\d.]+$/.test(attrValue)) {
      return NetworkFilter.filterIpv4(attrValue)
    }

    if (/^[\da-f:]+$/i.test(attrValue)) {
      return NetworkFilter.filterIpv6(attrValue)
    }

    return false
  },

  /**
   * @param  {*} attrValue
   * @return {*}
   */
  filterIpport: function(attrValue) {
    var m, ip

    if ((m = /^\[([\da-f:]+)(\]:[1-9]\d*)$/i.exec(attrValue))) {
      ip = NetworkFilter.filterIpv6(m[1])

      if (ip === false) {
        return false
      }

      return '[' + ip + m[2]
    }

    if ((m = /^([\d.]+)(:[1-9]\d*)$/.exec(attrValue))) {
      ip = NetworkFilter.filterIpv4(m[1])

      if (ip === false) {
        return false
      }

      return ip + m[2]
    }

    return false
  },

  /**
   * @param  {*} attrValue
   * @return {*}
   */
  filterIpv4: function(attrValue) {
    if (!/^\d+\.\d+\.\d+\.\d+$/.test(attrValue)) {
      return false
    }

    var i = 4,
      p = attrValue.split('.')
    while (--i >= 0) {
      // NOTE: ext/filter doesn't support octal notation
      if (p[i][0] === '0' || p[i] > 255) {
        return false
      }
    }

    return attrValue
  },

  /**
   * @param  {*} attrValue
   * @return {*}
   */
  filterIpv6: function(attrValue) {
    return /^([\da-f]{0,4}:){2,7}(?:[\da-f]{0,4}|\d+\.\d+\.\d+\.\d+)$/.test(
      attrValue,
    )
      ? attrValue
      : false
  },
}
/** @const */
var NumericFilter = {
  /**
   * @param  {*} attrValue
   * @return {*}
   */
  filterFloat: function(attrValue) {
    return /^(?:0|-?[1-9]\d*)(?:\.\d+)?(?:e[1-9]\d*)?$/i.test(attrValue)
      ? attrValue
      : false
  },

  /**
   * @param  {*} attrValue
   * @return {*}
   */
  filterInt: function(attrValue) {
    return /^(?:0|-?[1-9]\d*)$/.test(attrValue) ? attrValue : false
  },

  /**
   * @param  {*}       attrValue
   * @param  {number}  min
   * @param  {number}  max
   * @param  {?Logger} logger
   * @return {number|boolean}
   */
  filterRange: function(attrValue, min, max, logger) {
    if (!/^(?:0|-?[1-9]\d*)$/.test(attrValue)) {
      return false
    }

    attrValue = parseInt(attrValue, 10)

    if (attrValue < min) {
      if (logger) {
        logger.warn('Value outside of range, adjusted up to min value', {
          attrValue: attrValue,
          min: min,
          max: max,
        })
      }

      return min
    }

    if (attrValue > max) {
      if (logger) {
        logger.warn('Value outside of range, adjusted down to max value', {
          attrValue: attrValue,
          min: min,
          max: max,
        })
      }

      return max
    }

    return attrValue
  },

  /**
   * @param  {*} attrValue
   * @return {*}
   */
  filterUint: function(attrValue) {
    return /^(?:0|[1-9]\d*)$/.test(attrValue) ? attrValue : false
  },
}
/** @const */
var RegexpFilter = {
  /**
   * @param  {*} attrValue
   * @param  {!RegExp} regexp
   * @return {*}
   */
  filter: function(attrValue, regexp) {
    return regexp.test(attrValue) ? attrValue : false
  },
}
/** @const */
var TimestampFilter = {
  /**
   * @param  {*} attrValue
   * @return {*}
   */
  filter: function(attrValue) {
    var m = /^(?=\d)(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?$/.exec(attrValue)
    if (m) {
      return 3600 * (m[1] || 0) + 60 * (m[2] || 0) + (+m[3] || 0)
    }

    return NumericFilter.filterUint(attrValue)
  },
}
/** @const */
var UrlFilter = {
  /**
   * @param  {*}        attrValue
   * @param  {!Object}  urlConfig
   * @param  {?Logger=} logger
   * @return {*}
   */
  filter: function(attrValue, urlConfig, logger) {
    /**
     * Trim the URL to conform with HTML5 then parse it
     * @link http://dev.w3.org/html5/spec/links.html#attr-hyperlink-href
     */
    var p = UrlFilter.parseUrl(
      attrValue.replace(/^\s+/, '').replace(/\s+$/, ''),
    )

    var error = UrlFilter.validateUrl(urlConfig, p)
    if (error) {
      if (logger) {
        p['attrValue'] = attrValue
        logger.err(error, p)
      }

      return false
    }

    return UrlFilter.rebuildUrl(urlConfig, p)
  },

  /**
   * Parse a URL and return its components
   *
   * Similar to PHP's own parse_url() except that all parts are always returned
   *
   * @param  {string} url Original URL
   * @return {!Object}
   */
  parseUrl: function(url) {
    var regexp = /^(?:([a-z][-+.\w]*):)?(?:\/\/(?:([^:\/?#]*)(?::([^\/?#]*)?)?@)?(?:(\[[a-f\d:]+\]|[^:\/?#]+)(?::(\d*))?)?(?![^\/?#]))?([^?#]*)(\?[^#]*)?(#.*)?$/i

    // NOTE: this regexp always matches because of the last three captures
    var m = regexp['exec'](url),
      parts = {},
      tokens = [
        'scheme',
        'user',
        'pass',
        'host',
        'port',
        'path',
        'query',
        'fragment',
      ]
    tokens.forEach(function(name, i) {
      parts[name] = m[i + 1] > '' ? m[i + 1] : ''
    })

    /**
     * @link http://tools.ietf.org/html/rfc3986#section-3.1
     *
     * 'An implementation should accept uppercase letters as equivalent to lowercase in
     * scheme names (e.g., allow "HTTP" as well as "http") for the sake of robustness but
     * should only produce lowercase scheme names for consistency.'
     */
    parts['scheme'] = parts['scheme'].toLowerCase()

    /**
     * Normalize the domain label separators and remove trailing dots
     * @link http://url.spec.whatwg.org/#domain-label-separators
     */
    parts['host'] = parts['host']
      .replace(/[\u3002\uff0e\uff61]/g, '.')
      .replace(/\.+$/g, '')

    // Test whether host has non-ASCII characters and punycode it if possible
    if (/[^\x00-\x7F]/.test(parts['host']) && typeof punycode !== 'undefined') {
      parts['host'] = punycode.toASCII(parts['host'])
    }

    return parts
  },

  /**
   * Rebuild a parsed URL
   *
   * @param  {!Object} urlConfig
   * @param  {!Object} p
   * @return {string}
   */
  rebuildUrl: function(urlConfig, p) {
    var url = ''
    if (p['scheme'] !== '') {
      url += p['scheme'] + ':'
    }
    if (p['host'] !== '') {
      url += '//'

      // Add the credentials if applicable
      if (p['user'] !== '') {
        // Reencode the credentials in case there are invalid chars in them, or suspicious
        // characters such as : or @ that could confuse a browser into connecting to the
        // wrong host (or at least, to a host that is different than the one we thought)
        url += rawurlencode(decodeURIComponent(p['user']))

        if (p['pass'] !== '') {
          url += ':' + rawurlencode(decodeURIComponent(p['pass']))
        }

        url += '@'
      }

      url += p['host']

      // Append the port number (note that as per the regexp it can only contain digits)
      if (p['port'] !== '') {
        url += ':' + p['port']
      }
    } else if (p['scheme'] === 'file') {
      // Allow the file: scheme to not have a host and ensure it starts with slashes
      url += '//'
    }

    // Build the path, including the query and fragment parts
    var path = p['path'] + p['query'] + p['fragment']

    /**
     * "For consistency, URI producers and normalizers should use uppercase hexadecimal digits
     * for all percent- encodings."
     *
     * @link http://tools.ietf.org/html/rfc3986#section-2.1
     */
    path = path.replace(
      /%.?[a-f]/g,
      function(str) {
        return str.toUpperCase()
      },
      path,
    )

    // Append the sanitized path to the URL
    url += UrlFilter.sanitizeUrl(path)

    // Replace the first colon if there's no scheme and it could potentially be interpreted as
    // the scheme separator
    if (!p['scheme']) {
      url = url.replace(/^([^\/]*):/, '$1%3A')
    }

    return url
  },

  /**
   * Sanitize a URL for safe use regardless of context
   *
   * This method URL-encodes some sensitive characters in case someone would want to use the URL in
   * some JavaScript thingy, or in CSS. We also encode characters that are not allowed in the path
   * of a URL as defined in RFC 3986 appendix A, including percent signs that are not immediately
   * followed by two hex digits.
   *
   * " and ' to prevent breaking out of quotes (JavaScript or otherwise)
   * ( and ) to prevent the use of functions in JavaScript (eval()) or CSS (expression())
   * < and > to prevent breaking out of <script>
   * \r and \n because they're illegal in JavaScript
   * [ and ] because the W3 validator rejects them and they "should" be escaped as per RFC 3986
   * Non-ASCII characters as per RFC 3986
   * Control codes and spaces, as per RFC 3986
   *
   * @link http://sla.ckers.org/forum/read.php?2,51478
   * @link http://timelessrepo.com/json-isnt-a-javascript-subset
   * @link http://www.ietf.org/rfc/rfc3986.txt
   * @link http://stackoverflow.com/a/1547922
   * @link http://tools.ietf.org/html/rfc3986#appendix-A
   *
   * @param  {string} url Original URL
   * @return {string}     Sanitized URL
   */
  sanitizeUrl: function(url) {
    return url
      .replace(/[^\u0020-\u007E]+/g, encodeURIComponent)
      .replace(/%(?![0-9A-Fa-f]{2})|[^!#-&*-;=?-Z_a-z~]/g, escape)
  },

  /**
   * Validate a parsed URL
   *
   * @param  {!Object} urlConfig
   * @param  {!Object} p
   * @return {string|undefined}
   */
  validateUrl: function(urlConfig, p) {
    if (p['scheme'] !== '' && !urlConfig.allowedSchemes.test(p['scheme'])) {
      return 'URL scheme is not allowed'
    }

    if (p['host'] !== '') {
      /**
       * Test whether the host is valid
       * @link http://tools.ietf.org/html/rfc1035#section-2.3.1
       * @link http://tools.ietf.org/html/rfc1123#section-2
       */
      var regexp = /^(?!-)[-a-z0-9]{0,62}[a-z0-9](?:\.(?!-)[-a-z0-9]{0,62}[a-z0-9])*$/i
      if (!regexp.test(p['host'])) {
        // If the host invalid, retest as an IPv4 and IPv6 address (IPv6 in brackets)
        if (
          !NetworkFilter.filterIpv4(p['host']) &&
          !NetworkFilter.filterIpv6(
            p['host'].replace(/^\[(.*)\]$/, '$1', p['host']),
          )
        ) {
          return 'URL host is invalid'
        }
      }

      if (
        (urlConfig.disallowedHosts &&
          urlConfig.disallowedHosts.test(p['host'])) ||
        (urlConfig.restrictedHosts &&
          !urlConfig.restrictedHosts.test(p['host']))
      ) {
        return 'URL host is not allowed'
      }
    } else if (/^(?:(?:f|ht)tps?)$/.test(p['scheme'])) {
      return 'Missing host'
    }
  },
}
/**
 * @param  {string} str
 * @return {string}
 */
function html_entity_decode(str) {
  var b = document.createElement('b')
  html_entity_decode = function(str) {
    // We escape left brackets so that we don't inadvertently evaluate some nasty HTML such as
    // <img src=... onload=evil() />
    b.innerHTML = str.replace(/</g, '&lt;')

    return b.textContent
  }

  return html_entity_decode(str)
}

/**
 * @param  {string} str
 * @return {string}
 */
function htmlspecialchars_compat(str) {
  var t = {
    '<': '&lt;',
    '>': '&gt;',
    '&': '&amp;',
    '"': '&quot;',
  }
  return str.replace(
    /[<>&"]/g,
    /**
     * @param  {string} c
     * @return {string}
     */
    function(c) {
      return t[c]
    },
  )
}

/**
 * @param  {string} str
 * @return {string}
 */
function htmlspecialchars_noquotes(str) {
  var t = {
    '<': '&lt;',
    '>': '&gt;',
    '&': '&amp;',
  }
  return str.replace(
    /[<>&]/g,
    /**
     * @param  {string} c
     * @return {string}
     */
    function(c) {
      return t[c]
    },
  )
}

/**
 * @param  {string} str
 * @return {string}
 */
function rawurlencode(str) {
  return encodeURIComponent(str).replace(
    /[!'()*]/g,
    /**
     * @param  {string} c
     * @return {string}
     */
    function(c) {
      return (
        '%' +
        c
          .charCodeAt(0)
          .toString(16)
          .toUpperCase()
      )
    },
  )
}

/**
 * @return {boolean}
 */
function returnFalse() {
  return false
}

/**
 * @return {boolean}
 */
function returnTrue() {
  return true
}
/**
 * Execute all the attribute preprocessors of given tag
 *
 * @private
 *
 * @param {!Tag}    tag       Source tag
 * @param {!Object} tagConfig Tag's config
 */
function executeAttributePreprocessors(tag, tagConfig) {
  if (typeof tagConfig.attributePreprocessors === 'undefined') {
    return
  }

  tagConfig.attributePreprocessors.forEach(function(ap) {
    var attrName = ap[0],
      regexp = ap[1],
      map = ap[2]
    if (tag.hasAttribute(attrName)) {
      executeAttributePreprocessor(tag, attrName, regexp, map)
    }
  })
}

/**
 * Filter the attributes of given tag
 *
 * @private
 *
 * @param {!Tag}    tag            Tag being checked
 * @param {!Object} tagConfig      Tag's config
 * @param {!Object} registeredVars Unused
 * @param {!Logger} logger         This parser's Logger instance
 */
function filterAttributes(tag, tagConfig, registeredVars, logger) {
  var attributes = {},
    attrName
  for (attrName in tagConfig.attributes) {
    var attrConfig = tagConfig.attributes[attrName],
      attrValue = false
    if (tag.hasAttribute(attrName)) {
      attrValue = executeAttributeFilterChain(
        attrConfig.filterChain,
        attrName,
        tag.getAttribute(attrName),
      )
    }

    if (attrValue !== false) {
      attributes[attrName] = attrValue
    } else if (
      HINT.attributeDefaultValue &&
      typeof attrConfig.defaultValue !== 'undefined'
    ) {
      attributes[attrName] = attrConfig.defaultValue
    } else if (attrConfig.required) {
      tag.invalidate()
    }
  }
  tag.setAttributes(attributes)
}

/**
 * Execute a tag's filterChain
 *
 * @private
 *
 * @param {!Tag} tag Tag to filter
 */
function filterTag(tag) {
  var tagName = tag.getName(),
    tagConfig = tagsConfig[tagName]

  // Record the tag being processed into the logger it can be added to the context of
  // messages logged during the execution
  logger.setTag(tag)

  for (var i = 0; i < tagConfig.filterChain.length; ++i) {
    if (tag.isInvalid()) {
      break
    }
    tagConfig.filterChain[i](tag, tagConfig)
  }

  // Remove the tag from the logger
  logger.unsetTag()
}

/**
 * Execute an attribute's filterChain
 *
 * @param  {!Array} filterChain Attribute's filterChain
 * @param  {string} attrName    Attribute's name
 * @param  {*}      attrValue   Original value
 * @return {*}                  Filtered value
 */
function executeAttributeFilterChain(filterChain, attrName, attrValue) {
  logger.setAttribute(attrName)
  for (var i = 0; i < filterChain.length; ++i) {
    // NOTE: attrValue is intentionally set as the first argument to facilitate inlining
    attrValue = filterChain[i](attrValue, attrName)
    if (attrValue === false) {
      break
    }
  }
  logger.unsetAttribute()

  return attrValue
}

/**
 * Execute an attribute preprocessor
 *
 * @param  {!Tag}           tag
 * @param  {string}         attrName
 * @param  {!RegExp}        regexp
 * @param  {!Array<string>} map
 */
function executeAttributePreprocessor(tag, attrName, regexp, map) {
  var attrValue = tag.getAttribute(attrName),
    captures = getNamedCaptures(attrValue, regexp, map),
    k
  for (k in captures) {
    // Attribute preprocessors cannot overwrite other attributes but they can
    // overwrite themselves
    if (k === attrName || !tag.hasAttribute(k)) {
      tag.setAttribute(k, captures[k])
    }
  }
}

/**
 * Execute a regexp and return the values of the mapped captures
 *
 * @param  {string}                 attrValue
 * @param  {!RegExp}                regexp
 * @param  {!Array<string>}         map
 * @return {!Object<string,string>}
 */
function getNamedCaptures(attrValue, regexp, map) {
  var m = regexp.exec(attrValue)
  if (!m) {
    return []
  }

  var values = {}
  map.forEach(function(k, i) {
    if (typeof m[i] === 'string' && m[i] !== '') {
      values[k] = m[i]
    }
  })

  return values
}
/**@constructor*/ function Logger() {}
Logger.prototype = {
  /**
   * Add a log entry
   *
   * @param  {string}   type    Log type
   * @param  {string}   msg     Log message
   * @param  {!Object=} context Log context
   */
  add: function(type, msg, context) {},
  /**
   * Clear the log
   */
  clear: function() {},
  /**
   * Record the name of the attribute being processed
   *
   * @param {string} attrName
   */
  setAttribute: function(attrName) {},
  /**
   * Record the tag being processed
   *
   * @param {!Tag} tag
   */
  setTag: function(tag) {},
  /**
   * Unset the name of the attribute being processed
   */
  unsetAttribute: function() {},
  /**
   * Unset the tag being processed
   */
  unsetTag: function() {},
  /**
   * Add a "debug" type log entry
   *
   * @param  {string}   msg     Log message
   * @param  {!Object=} context Log context
   */
  debug: function(msg, context) {},
  /**
   * Add an "err" type log entry
   *
   * @param  {string}   msg     Log message
   * @param  {!Object=} context Log context
   */
  err: function(msg, context) {},
  /**
   * Add an "info" type log entry
   *
   * @param  {string}   msg     Log message
   * @param  {!Object=} context Log context
   */
  info: function(msg, context) {},
  /**
   * Add a "warn" type log entry
   *
   * @param  {string}   msg     Log message
   * @param  {!Object=} context Log context
   */
  warn: function(msg, context) {},
}
/**
 * @constructor
 *
 * @param {number} type     Tag's type
 * @param {string} name     Name of the tag
 * @param {number} pos      Position of the tag in the text
 * @param {number} len      Length of text consumed by the tag
 * @param {number=} priority This tag's sorting tiebreaker
 */
function Tag(type, name, pos, len, priority) {
  this.type = +type
  this.name = name
  this.pos = +pos
  this.len = +len
  this.sortPriority = +priority || 0

  this.attributes = {}
  this.cascade = []

  // Invalidate this tag now if any value is not a number, they could wreck
  // havoc in other parts of the program
  if (isNaN(type + pos + len)) {
    this.invalidate()
  }
}

/** @const */
Tag.START_TAG = 1

/** @const */
Tag.END_TAG = 2

/** @const */
Tag.SELF_CLOSING_TAG = 3

/**
 * @type {!Object} Dictionary of attributes
 */
Tag.prototype.attributes

/**
 * @type {!Array.<!Tag>} List of tags that are invalidated when this tag is invalidated
 */
Tag.prototype.cascade

/**
 * @type {?Tag} End tag that unconditionally ends this start tag
 */
Tag.prototype.endTag

/**
 * @type {boolean} Whether this tag is be invalid
 */
Tag.prototype.invalid = false

/**
 * @type {number} Length of text consumed by this tag
 */
Tag.prototype.len

/**
 * @type {string} Name of this tag
 */
Tag.prototype.name

/**
 * @type {number} Position of this tag in the text
 */
Tag.prototype.pos

/**
 * @type {number} Tiebreaker used when sorting identical tags
 */
Tag.prototype.sortPriority

/**
 * @type {?Tag} Start tag that is unconditionally closed this end tag
 */
Tag.prototype.startTag

/**
 * @type {number} Tag type
 */
Tag.prototype.type

/**
 * Add a set of flags to this tag's
 *
 * @param {number} flags
 */
Tag.prototype.addFlags = function(flags) {
  this.flags |= flags
}

/**
 * Set given tag to be invalidated if this tag is invalidated
 *
 * @param {!Tag} tag
 */
Tag.prototype.cascadeInvalidationTo = function(tag) {
  this.cascade.push(tag)

  // If this tag is already invalid, cascade it now
  if (this.invalid) {
    tag.invalidate()
  }
}

/**
 * Invalidate this tag, as well as tags bound to this tag
 */
Tag.prototype.invalidate = function() {
  // Only invalidate if this tag is valid to prevent infinite loops
  if (!this.invalid) {
    this.invalid = true
    this.cascade.forEach(
      /**
       * @param {!Tag} tag
       */
      function(tag) {
        tag.invalidate()
      },
    )
  }
}

/**
 * Pair this tag with given tag
 *
 * @param {!Tag} tag
 */
Tag.prototype.pairWith = function(tag) {
  if (this.canBePaired(this, tag)) {
    this.endTag = tag
    tag.startTag = this

    this.cascadeInvalidationTo(tag)
  } else if (this.canBePaired(tag, this)) {
    this.startTag = tag
    tag.endTag = this
  }
}

/**
 * Test whether two tags can be paired
 *
 * @param  {!Tag} startTag
 * @param  {!Tag} endTag
 * @return {boolean}
 */
Tag.prototype.canBePaired = function(startTag, endTag) {
  return (
    startTag.name === endTag.name &&
    startTag.type === Tag.START_TAG &&
    endTag.type === Tag.END_TAG &&
    startTag.pos <= startTag.pos
  )
}

/**
 * Remove a set of flags from this tag's
 *
 * @param {number} flags
 */
Tag.prototype.removeFlags = function(flags) {
  this.flags &= ~flags
}

/**
 * Set the bitfield of boolean rules that apply to this tag
 *
 * @param {number} flags Bitfield of boolean rules that apply to this tag
 */
Tag.prototype.setFlags = function(flags) {
  this.flags = flags
}

//==========================================================================
// Getters
//==========================================================================

/**
 * Return this tag's attributes
 *
 * @return {!Object}
 */
Tag.prototype.getAttributes = function() {
  var attributes = {}
  for (var attrName in this.attributes) {
    attributes[attrName] = this.attributes[attrName]
  }

  return attributes
}

/**
 * Return this tag's end tag
 *
 * @return {?Tag} This tag's end tag
 */
Tag.prototype.getEndTag = function() {
  return this.endTag
}

/**
 * Return the bitfield of boolean rules that apply to this tag
 *
 * @return {number}
 */
Tag.prototype.getFlags = function() {
  return this.flags
}

/**
 * Return the length of text consumed by this tag
 *
 * @return {number}
 */
Tag.prototype.getLen = function() {
  return this.len
}

/**
 * Return this tag's name
 *
 * @return {string}
 */
Tag.prototype.getName = function() {
  return this.name
}

/**
 * Return this tag's position
 *
 * @return {number}
 */
Tag.prototype.getPos = function() {
  return this.pos
}

/**
 * Return this tag's tiebreaker
 *
 * @return {number}
 */
Tag.prototype.getSortPriority = function() {
  return this.sortPriority
}

/**
 * Return this tag's start tag
 *
 * @return {?Tag} This tag's start tag
 */
Tag.prototype.getStartTag = function() {
  return this.startTag
}

/**
 * Return this tag's type
 *
 * @return {number}
 */
Tag.prototype.getType = function() {
  return this.type
}

//==========================================================================
// Tag's status
//==========================================================================

/**
 * Test whether this tag can close given start tag
 *
 * @param  {!Tag} startTag
 * @return {boolean}
 */
Tag.prototype.canClose = function(startTag) {
  if (
    this.invalid ||
    !this.canBePaired(startTag, this) ||
    (this.startTag && this.startTag !== startTag) ||
    (startTag.endTag && startTag.endTag !== this)
  ) {
    return false
  }

  return true
}

/**
 * Test whether this tag is a br tag
 *
 * @return {boolean}
 */
Tag.prototype.isBrTag = function() {
  return this.name === 'br'
}

/**
 * Test whether this tag is an end tag (self-closing tags inclusive)
 *
 * @return {boolean}
 */
Tag.prototype.isEndTag = function() {
  return !!(this.type & Tag.END_TAG)
}

/**
 * Test whether this tag is an ignore tag
 *
 * @return {boolean}
 */
Tag.prototype.isIgnoreTag = function() {
  return this.name === 'i'
}

/**
 * Test whether this tag is invalid
 *
 * @return {boolean}
 */
Tag.prototype.isInvalid = function() {
  return this.invalid
}

/**
 * Test whether this tag represents a paragraph break
 *
 * @return {boolean}
 */
Tag.prototype.isParagraphBreak = function() {
  return this.name === 'pb'
}

/**
 * Test whether this tag is a self-closing tag
 *
 * @return {boolean}
 */
Tag.prototype.isSelfClosingTag = function() {
  return this.type === Tag.SELF_CLOSING_TAG
}

/**
 * Test whether this tag is a special tag: "br", "i", "pb" or "v"
 *
 * @return {boolean}
 */
Tag.prototype.isSystemTag = function() {
  return 'br i pb v'.indexOf(this.name) > -1
}

/**
 * Test whether this tag is a start tag (self-closing tags inclusive)
 *
 * @return {boolean}
 */
Tag.prototype.isStartTag = function() {
  return !!(this.type & Tag.START_TAG)
}

/**
 * Test whether this tag represents verbatim text
 *
 * @return {boolean}
 */
Tag.prototype.isVerbatim = function() {
  return this.name === 'v'
}

//==========================================================================
// Attributes handling
//==========================================================================

/**
 * Return the value of given attribute
 *
 * @param  {string} attrName
 * @return {string}
 */
Tag.prototype.getAttribute = function(attrName) {
  return this.attributes[attrName]
}

/**
 * Return whether given attribute is set
 *
 * @param  {string} attrName
 * @return {boolean}
 */
Tag.prototype.hasAttribute = function(attrName) {
  return attrName in this.attributes
}

/**
 * Remove given attribute
 *
 * @param {string} attrName
 */
Tag.prototype.removeAttribute = function(attrName) {
  delete this.attributes[attrName]
}

/**
 * Set the value of an attribute
 *
 * @param {string} attrName  Attribute's name
 * @param {*}       attrValue Attribute's value
 */
Tag.prototype.setAttribute = function(attrName, attrValue) {
  this.attributes[attrName] = attrValue
}

/**
 * Set all of this tag's attributes at once
 *
 * @param {!Object} attributes
 */
Tag.prototype.setAttributes = function(attributes) {
  this.attributes = {}
  for (var attrName in attributes) {
    this.attributes[attrName] = attributes[attrName]
  }
}
/**#@+
 * Boolean rules bitfield
 */
/** @const */ var RULE_AUTO_CLOSE = 1 << 0
/** @const */ var RULE_AUTO_REOPEN = 1 << 1
/** @const */ var RULE_BREAK_PARAGRAPH = 1 << 2
/** @const */ var RULE_CREATE_PARAGRAPHS = 1 << 3
/** @const */ var RULE_DISABLE_AUTO_BR = 1 << 4
/** @const */ var RULE_ENABLE_AUTO_BR = 1 << 5
/** @const */ var RULE_IGNORE_TAGS = 1 << 6
/** @const */ var RULE_IGNORE_TEXT = 1 << 7
/** @const */ var RULE_IGNORE_WHITESPACE = 1 << 8
/** @const */ var RULE_IS_TRANSPARENT = 1 << 9
/** @const */ var RULE_PREVENT_BR = 1 << 10
/** @const */ var RULE_SUSPEND_AUTO_BR = 1 << 11
/** @const */ var RULE_TRIM_FIRST_LINE = 1 << 12
/**#@-*/

/**
 * @const Bitwise disjunction of rules related to automatic line breaks
 */
var RULES_AUTO_LINEBREAKS =
  RULE_DISABLE_AUTO_BR | RULE_ENABLE_AUTO_BR | RULE_SUSPEND_AUTO_BR

/**
 * @const Bitwise disjunction of rules that are inherited by subcontexts
 */
var RULES_INHERITANCE = RULE_ENABLE_AUTO_BR

/**
 * @const All the characters that are considered whitespace
 */
var WHITESPACE = ' \n\t'

/**
 * @type {!Object.<string,number>} Number of open tags for each tag name
 */
var cntOpen

/**
 * @type {!Object.<string,number>} Number of times each tag has been used
 */
var cntTotal

/**
 * @type {!Object} Current context
 */
var context

/**
 * @type {number} How hard the parser has worked on fixing bad markup so far
 */
var currentFixingCost

/**
 * @type {?Tag} Current tag being processed
 */
var currentTag

/**
 * @type {boolean} Whether the output contains "rich" tags, IOW any tag that is not <p> or <br/>
 */
var isRich

/**
 * @type {!Logger} This parser's logger
 */
var logger = new Logger()

/**
 * @type {number} How hard the parser should work on fixing bad markup
 */
var maxFixingCost = 10000

/**
 * @type {!Object} Associative array of namespace prefixes in use in document (prefixes used as key)
 */
var namespaces

/**
 * @type {!Array.<!Tag>} Stack of open tags (instances of Tag)
 */
var openTags

/**
 * @type {string} This parser's output
 */
var output

/**
 * @type {!Object.<!Object>}
 */
var plugins = {
  Autoemail: {
    /**
     * @param {string}          text
     * @param {!Array.<!Array>} matches
     */
    parser: function(text, matches) {
      /** @const */
      var config = { attrName: 'email', tagName: 'EMAIL' }
      var tagName = config.tagName,
        attrName = config.attrName

      matches.forEach(function(m) {
        // Create a zero-width start tag right before the address
        var startTag = addStartTag(tagName, m[0][1], 0)
        startTag.setAttribute(attrName, m[0][0])

        // Create a zero-width end tag right after the address
        var endTag = addEndTag(tagName, m[0][1] + m[0][0].length, 0)

        // Pair the tags together
        startTag.pairWith(endTag)
      })
    },
    quickMatch: '@',
    regexp: /\b[-a-z0-9_+.]+@[-a-z0-9.]*[a-z0-9]/gi,
    regexpLimit: 50000,
  },
  Autolink: {
    /**
     * @param {string}          text
     * @param {!Array.<!Array>} matches
     */
    parser: function(text, matches) {
      /** @const */
      var config = { attrName: 'url', tagName: 'URL' }
      matches.forEach(function(m) {
        // Linkify the trimmed URL
        linkifyUrl(m[0][1], trimUrl(m[0][0]))
      })

      /**
       * Linkify given URL at given position
       *
       * @param {number} tagPos URL's position in the text
       * @param {string} url    URL
       */
      function linkifyUrl(tagPos, url) {
        // Ensure that the anchor (scheme/www) is still there
        if (!/^www\.|^[^:]+:/i.test(url)) {
          return
        }

        // Create a zero-width end tag right after the URL
        var endPos = tagPos + url.length,
          endTag = addEndTag(config.tagName, endPos, 0)

        // If the URL starts with "www." we prepend "http://"
        if (url[3] === '.') {
          url = 'http://' + url
        }

        // Create a zero-width start tag right before the URL, with a slightly worse priority to
        // allow specialized plugins to use the URL instead
        var startTag = addStartTag(config.tagName, tagPos, 0, 1)
        startTag.setAttribute(config.attrName, url)

        // Pair the tags together
        startTag.pairWith(endTag)

        // Protect the tag's content from partial replacements with a low priority tag
        var contentTag = addVerbatim(tagPos, endPos - tagPos, 1000)
        startTag.cascadeInvalidationTo(contentTag)
      }

      /**
       * Remove trailing punctuation from given URL
       *
       * We remove most ASCII non-letters from the end of the string.
       * Exceptions:
       *  - dashes and underscores, (base64 IDs could end with one)
       *  - equal signs, (because of "foo?bar=")
       *  - trailing slashes,
       *  - closing parentheses. (they are balanced separately)
       *
       * @param  {string} url Original URL
       * @return {string}     Trimmed URL
       */
      function trimUrl(url) {
        return url.replace(/(?:(?![-=)\/_])[\s!-.:-@[-`{-~])+$/, '')
      }
    },
    quickMatch: ':',
    regexp: /\bhttps?:(?:[^\s()\[\]\uFF01-\uFF0F\uFF1A-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65]|\([^\s()]*\)|\[\w*\])+/gi,
    regexpLimit: 50000,
  },
  BBCodes: {
    /**
     * @param {string}          text
     * @param {!Array.<!Array>} matches
     */
    parser: function(text, matches) {
      /** @const */
      var config = {
        bbcodes: {
          '*': { tagName: 'LI' },
          B: [],
          CENTER: [],
          CODE: { defaultAttribute: 'lang' },
          COLOR: [],
          DEL: [],
          EMAIL: { contentAttributes: ['email'] },
          I: [],
          IMG: { contentAttributes: ['src'], defaultAttribute: 'src' },
          LIST: { defaultAttribute: 'type' },
          QUOTE: { defaultAttribute: 'author' },
          S: [],
          SIZE: [],
          U: [],
          'UPL-FILE': {
            contentAttributes: ['content'],
            defaultAttribute: 'uuid',
          },
          'UPL-IMAGE': {
            contentAttributes: ['content'],
            defaultAttribute: 'uuid',
          },
          'UPL-IMAGE-PREVIEW': { defaultAttribute: 'url' },
          URL: { contentAttributes: ['url'] },
        },
      }
      /**
       * @type {!Object} Attributes of the BBCode being parsed
       */
      var attributes

      /**
       * @type {!Object} Configuration for the BBCode being parsed
       */
      var bbcodeConfig

      /**
       * @type {string} Name of the BBCode being parsed
       */
      var bbcodeName

      /**
       * @type {string} Suffix of the BBCode being parsed, including its colon
       */
      var bbcodeSuffix

      /**
       * @type {number} Position of the cursor in the original text
       */
      var pos

      /**
       * @type {number} Position of the start of the BBCode being parsed
       */
      var startPos

      /**
       * @type {number} Length of the text being parsed
       */
      var textLen = text.length

      /**
       * @type {string} Text being parsed, normalized to uppercase
       */
      var uppercaseText = ''

      matches.forEach(function(m) {
        bbcodeName = m[1][0].toUpperCase()
        if (!(bbcodeName in config.bbcodes)) {
          return
        }
        bbcodeConfig = config.bbcodes[bbcodeName]
        startPos = m[0][1]
        pos = startPos + m[0][0].length

        try {
          parseBBCode()
        } catch (e) {
          // Do nothing
        }
      })

      /**
       * Add the end tag that matches current BBCode
       *
       * @return {!Tag}
       */
      function addBBCodeEndTag() {
        return addEndTag(getTagName(), startPos, pos - startPos)
      }

      /**
       * Add the self-closing tag that matches current BBCode
       *
       * @return {!Tag}
       */
      function addBBCodeSelfClosingTag() {
        var tag = addSelfClosingTag(getTagName(), startPos, pos - startPos)
        tag.setAttributes(attributes)

        return tag
      }

      /**
       * Add the start tag that matches current BBCode
       *
       * @return {!Tag}
       */
      function addBBCodeStartTag() {
        var tag = addStartTag(getTagName(), startPos, pos - startPos)
        tag.setAttributes(attributes)

        return tag
      }

      /**
       * Parse the end tag that matches given BBCode name and suffix starting at current position
       *
       * @return {?Tag}
       */
      function captureEndTag() {
        if (!uppercaseText) {
          uppercaseText = text.toUpperCase()
        }
        var match = '[/' + bbcodeName + bbcodeSuffix + ']',
          endTagPos = uppercaseText.indexOf(match, pos)
        if (endTagPos < 0) {
          return null
        }

        return addEndTag(getTagName(), endTagPos, match.length)
      }

      /**
       * Get the tag name for current BBCode
       *
       * @return {string}
       */
      function getTagName() {
        // Use the configured tagName if available, or reuse the BBCode's name otherwise
        return bbcodeConfig.tagName || bbcodeName
      }

      /**
       * Parse attributes starting at current position
       */
      function parseAttributes() {
        var firstPos = pos,
          attrName
        attributes = {}
        while (pos < textLen) {
          var c = text[pos]
          if (' \n\t'.indexOf(c) > -1) {
            ++pos
            continue
          }
          if ('/]'.indexOf(c) > -1) {
            return
          }

          // Capture the attribute name
          var spn = /^[-\w]*/.exec(text.substr(pos, 100))[0].length
          if (spn) {
            attrName = text.substr(pos, spn).toLowerCase()
            pos += spn
            if (pos >= textLen) {
              // The attribute name extends to the end of the text
              throw ''
            }
            if (text[pos] !== '=') {
              // It's an attribute name not followed by an equal sign, ignore it
              continue
            }
          } else if (c === '=' && pos === firstPos) {
            // This is the default param, e.g. [quote=foo]
            attrName = bbcodeConfig.defaultAttribute || bbcodeName.toLowerCase()
          } else {
            throw ''
          }

          // Move past the = and make sure we're not at the end of the text
          if (++pos >= textLen) {
            throw ''
          }

          attributes[attrName] = parseAttributeValue()
        }
      }

      /**
       * Parse the attribute value starting at current position
       *
       * @return {string}
       */
      function parseAttributeValue() {
        // Test whether the value is in quotes
        if (text[pos] === '"' || text[pos] === "'") {
          return parseQuotedAttributeValue()
        }

        // Capture everything up to whichever comes first:
        //  - an endline
        //  - whitespace followed by a slash and a closing bracket
        //  - a closing bracket, optionally preceded by whitespace
        //  - whitespace followed by another attribute (name followed by equal sign)
        //
        // NOTE: this is for compatibility with some forums (such as vBulletin it seems)
        //       that do not put attribute values in quotes, e.g.
        //       [quote=John Smith;123456] (quoting "John Smith" from post #123456)
        var match = /(?:[^\s\]]|[ \t](?!\s*(?:[-\w]+=|\/?\])))*/.exec(
            text.substr(pos),
          ),
          attrValue = match[0]
        pos += attrValue.length

        return attrValue
      }

      /**
       * Parse current BBCode
       */
      function parseBBCode() {
        parseBBCodeSuffix()

        // Test whether this is an end tag
        if (text[startPos + 1] === '/') {
          // Test whether the tag is properly closed and whether this tag has an identifier.
          // We skip end tags that carry an identifier because they're automatically added
          // when their start tag is processed
          if (text[pos] === ']' && bbcodeSuffix === '') {
            ++pos
            addBBCodeEndTag()
          }

          return
        }

        // Parse attributes and fill in the blanks with predefined attributes
        parseAttributes()
        if (bbcodeConfig.predefinedAttributes) {
          for (var attrName in bbcodeConfig.predefinedAttributes) {
            if (!(attrName in attributes)) {
              attributes[attrName] = bbcodeConfig.predefinedAttributes[attrName]
            }
          }
        }

        // Test whether the tag is properly closed
        if (text[pos] === ']') {
          ++pos
        } else {
          // Test whether this is a self-closing tag
          if (text.substr(pos, 2) === '/]') {
            pos += 2
            addBBCodeSelfClosingTag()
          }

          return
        }

        // Record the names of attributes that need the content of this tag
        var contentAttributes = []
        if (bbcodeConfig.contentAttributes) {
          bbcodeConfig.contentAttributes.forEach(function(attrName) {
            if (!(attrName in attributes)) {
              contentAttributes.push(attrName)
            }
          })
        }

        // Look ahead and parse the end tag that matches this tag, if applicable
        var requireEndTag = (bbcodeSuffix || bbcodeConfig.forceLookahead),
          endTag =
            (requireEndTag || contentAttributes.length) ? captureEndTag() : null
        if (endTag) {
          contentAttributes.forEach(function(attrName) {
            attributes[attrName] = text.substr(pos, endTag.getPos() - pos)
          })
        } else if (requireEndTag) {
          return
        }

        // Create this start tag
        var tag = addBBCodeStartTag()

        // If an end tag was created, pair it with this start tag
        if (endTag) {
          tag.pairWith(endTag)
        }
      }

      /**
       * Parse the BBCode suffix starting at current position
       *
       * Used to explicitly pair specific tags together, e.g.
       *   [code:123][code]type your code here[/code][/code:123]
       */
      function parseBBCodeSuffix() {
        bbcodeSuffix = ''
        if (text[pos] === ':') {
          // Capture the colon and the (0 or more) digits following it
          bbcodeSuffix = /^:\d*/.exec(text.substr(pos))[0]

          // Move past the suffix
          pos += bbcodeSuffix.length
        }
      }

      /**
       * Parse a quoted attribute value that starts at current offset
       *
       * @return {string}
       */
      function parseQuotedAttributeValue() {
        var quote = text[pos],
          valuePos = pos + 1
        do {
          // Look for the next quote
          pos = text.indexOf(quote, pos + 1)
          if (pos < 0) {
            // No matching quote. Apparently that string never ends...
            throw ''
          }

          // Test for an odd number of backslashes before this character
          var n = 1
          while (text[pos - n] === '\\') {
            ++n
          }
        } while (n % 2 === 0)

        var attrValue = text.substr(valuePos, pos - valuePos)
        if (attrValue.indexOf('\\') > -1) {
          attrValue = attrValue.replace(/\\([\\'"])/g, '$1')
        }

        // Skip past the closing quote
        ++pos

        return attrValue
      }
    },
    quickMatch: '[',
    regexp: /\[\/?(\*|[-\w]+)(?=[\]\s=:\/])/g,
    regexpLimit: 50000,
  },
  Emoticons: {
    /**
     * @param {string}          text
     * @param {!Array.<!Array>} matches
     */
    parser: function(text, matches) {
      /** @const */
      var config = { tagName: 'E' }
      matches.forEach(function(m) {
        if (
          HINT.EMOTICONS_NOT_AFTER &&
          config.notAfter &&
          m[0][1] &&
          config.notAfter.test(text[m[0][1] - 1])
        ) {
          return
        }

        addSelfClosingTag(config.tagName, m[0][1], m[0][0].length)
      })
    },
    regexp: /(?::(?:[()DOP|]|'\()|;\)|>:\()/g,
    regexpLimit: 50000,
  },
  Escaper: {
    /**
     * @param {string}          text
     * @param {!Array.<!Array>} matches
     */
    parser: function(text, matches) {
      /** @const */
      var config = { tagName: 'ESC' }
      matches.forEach(function(m) {
        addTagPair(config.tagName, m[0][1], 1, m[0][1] + m[0][0].length, 0)
      })
    },
    quickMatch: '\\',
    regexp: /\\[-!#()*+.:<>@[\\\]^_`{|}~]/g,
    regexpLimit: 50000,
  },
  Litedown: {
    /**
     * @param {string}          text
     * @param {!Array.<!Array>} matches
     */
    parser: function(text, matches) {
      /** @const */
      var config = { decodeHtmlEntities: !1 }
      /**
       * @type {boolean} Whether to decode HTML entities when decoding text
       */
      var decodeHtmlEntities = config.decodeHtmlEntities

      /**
       * @type {boolean} Whether text contains escape characters
       */
      var hasEscapedChars = false

      /**
       * @type {boolean} Whether text contains link references
       */
      var hasReferences = false

      /**
       * @dict
       */
      var linkReferences = {}

      if (text.indexOf('\\') >= 0) {
        hasEscapedChars = true

        // Encode escaped literals that have a special meaning otherwise, so that we don't have
        // to take them into account in regexps
        text = text.replace(/\\[!"'()*[\\\]^_`~]/g, function(str) {
          return {
            '\\!': '\x1B0',
            '\\"': '\x1B1',
            "\\'": '\x1B2',
            '\\(': '\x1B3',
            '\\)': '\x1B4',
            '\\*': '\x1B5',
            '\\[': '\x1B6',
            '\\\\': '\x1B7',
            '\\]': '\x1B8',
            '\\^': '\x1B9',
            '\\_': '\x1BA',
            '\\`': '\x1BB',
            '\\~': '\x1BC',
          }[str]
        })
      }

      // We append a couple of lines and a non-whitespace character at the end of the text in
      // order to trigger the closure of all open blocks such as quotes and lists
      text += '\n\n\x17'

      /**
       * Decode a chunk of encoded text to be used as an attribute value
       *
       * Decodes escaped literals and removes slashes and 0x1A characters
       *
       * @param  {string} str Encoded text
       * @return {string}     Decoded text
       */
      function decode(str) {
        if (
          HINT.LITEDOWN_DECODE_HTML_ENTITIES &&
          decodeHtmlEntities &&
          str.indexOf('&') > -1
        ) {
          str = html_entity_decode(str)
        }
        str = str.replace(/\x1A/g, '')

        if (hasEscapedChars) {
          str = str.replace(/\x1B./g, function(seq) {
            return {
              '\x1B0': '!',
              '\x1B1': '"',
              '\x1B2': "'",
              '\x1B3': '(',
              '\x1B4': ')',
              '\x1B5': '*',
              '\x1B6': '[',
              '\x1B7': '\\',
              '\x1B8': ']',
              '\x1B9': '^',
              '\x1BA': '_',
              '\x1BB': '`',
              '\x1BC': '~',
            }[seq]
          })
        }

        return str
      }

      /**
       * Test whether given position is preceded by whitespace
       *
       * @param  {number}  pos
       * @return {boolean}
       */
      function isAfterWhitespace(pos) {
        return (pos > 0 && isWhitespace(text.charAt(pos - 1)))
      }

      /**
       * Test whether given character is alphanumeric
       *
       * @param  {string}  chr
       * @return {boolean}
       */
      function isAlnum(chr) {
        return (
          (' abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'.indexOf(
            chr,
          ) > 0)
        )
      }

      /**
       * Test whether given position is followed by whitespace
       *
       * @param  {number}  pos
       * @return {boolean}
       */
      function isBeforeWhitespace(pos) {
        return isWhitespace(text[pos + 1])
      }

      /**
       * Test whether a length of text is surrounded by alphanumeric characters
       *
       * @param  {number}  pos Start of the text
       * @param  {number}  len Length of the text
       * @return {boolean}
       */
      function isSurroundedByAlnum(pos, len) {
        return (pos > 0 && isAlnum(text[pos - 1]) && isAlnum(text[pos + len]))
      }

      /**
       * Test whether given character is an ASCII whitespace character
       *
       * NOTE: newlines are normalized to LF before parsing so we don't have to check for CR
       *
       * @param  {string}  chr
       * @return {boolean}
       */
      function isWhitespace(chr) {
        return (' \n\t'.indexOf(chr) > -1)
      }

      /**
       * Mark the boundary of a block in the original text
       *
       * @param {number} pos
       */
      function markBoundary(pos) {
        text = text.substr(0, pos) + '\x17' + text.substr(pos + 1)
      }

      /**
       * Overwrite part of the text with substitution characters ^Z (0x1A)
       *
       * @param  {number} pos Start of the range
       * @param  {number} len Length of text to overwrite
       */
      function overwrite(pos, len) {
        if (len > 0) {
          text =
            text.substr(0, pos) +
            new Array(1 + len).join('\x1A') +
            text.substr(pos + len)
        }
      }
      /**
       * Parse given inline markup in text
       *
       * The markup must start and end with exactly 2 characters
       *
       * @param {string}  str     First markup string
       * @param {!RegExp} regexp  Regexp used to match the markup's span
       * @param {string}  tagName Name of the tag produced by this markup
       */
      function parseInlineMarkup(str, regexp, tagName) {
        if (text.indexOf(str) === -1) {
          return
        }

        var m
        while ((m = regexp.exec(text))) {
          var match = m[0],
            matchPos = m.index,
            matchLen = match.length,
            endPos = matchPos + matchLen - 2

          addTagPair(tagName, matchPos, 2, endPos, 2)
          overwrite(matchPos, 2)
          overwrite(endPos, 2)
        }
      }
      /**
       * @param {string}  tagName     Name of the tag used by this pass
       * @param {string}  syntaxChar  Relevant character used by this syntax
       * @param {!RegExp} shortRegexp Regexp used for the short form syntax
       * @param {!RegExp} longRegexp  Regexp used for the long form syntax
       */
      function parseAbstractScript(
        tagName,
        syntaxChar,
        shortRegexp,
        longRegexp,
      ) {
        var pos = text.indexOf(syntaxChar)
        if (pos === -1) {
          return
        }

        parseShortForm(pos)
        parseLongForm(pos)

        /**
         * Parse the long form x^(x)
         *
         * This syntax is supported by RDiscount
         *
         * @param {number} pos Position of the first relevant character
         */
        function parseLongForm(pos) {
          pos = text.indexOf(syntaxChar + '(', pos)
          if (pos === -1) {
            return
          }

          var m,
            regexp = longRegexp
          regexp.lastIndex = pos
          while ((m = regexp.exec(text))) {
            var match = m[0],
              matchPos = m.index,
              matchLen = match.length

            addTagPair(tagName, matchPos, 2, matchPos + matchLen - 1, 1)
            overwrite(matchPos, matchLen)
          }
          if (match) {
            parseLongForm(pos)
          }
        }

        /**
         * Parse the short form x^x and x^x^
         *
         * This syntax is supported by most implementations that support superscript
         *
         * @param {number} pos Position of the first relevant character
         */
        function parseShortForm(pos) {
          var m,
            regexp = shortRegexp
          regexp.lastIndex = pos
          while ((m = regexp.exec(text))) {
            var match = m[0],
              matchPos = m.index,
              matchLen = match.length,
              startPos = matchPos,
              endLen = (match.substr(-1) === syntaxChar) ? 1 : 0,
              endPos = matchPos + matchLen - endLen

            addTagPair(tagName, startPos, 1, endPos, endLen)
          }
        }
      }
      /**
       * Set a URL or IMG tag's attributes
       *
       * @param {!Tag}    tag      URL or IMG tag
       * @param {string} linkInfo Link's info: an URL optionally followed by spaces and a title
       * @param {string} attrName Name of the URL attribute
       */
      function setLinkAttributes(tag, linkInfo, attrName) {
        var url = linkInfo.replace(/^\s*/, '').replace(/\s*$/, ''),
          title = '',
          pos = url.indexOf(' ')
        if (pos !== -1) {
          title = url
            .substr(pos)
            .replace(/^\s*\S/, '')
            .replace(/\S\s*$/, '')
          url = url.substr(0, pos)
        }

        tag.setAttribute(attrName, decode(url))
        if (title > '') {
          tag.setAttribute('title', decode(title))
        }
      }
      ;(function() {
        var setextLines = {}

        function parse() {
          matchSetextLines()

          var blocks = [],
            blocksCnt = 0,
            codeFence,
            codeIndent = 4,
            codeTag,
            lineIsEmpty = true,
            lists = [],
            listsCnt = 0,
            newContext = false,
            textBoundary = 0,
            breakParagraph,
            continuation,
            ignoreLen,
            indentStr,
            indentLen,
            lfPos,
            listIndex,
            maxIndent,
            minIndent,
            blockDepth,
            tagPos,
            tagLen

          // Capture all the lines at once so that we can overwrite newlines safely, without preventing
          // further matches
          var matches = [],
            m,
            regexp = /^(?:(?=[-*+\d \t>`~#_])((?: {0,3}>(?:(?!!)|!(?![^\n>]*?!<)) ?)+)?([ \t]+)?(\* *\* *\*[* ]*$|- *- *-[- ]*$|_ *_ *_[_ ]*$)?((?:[-*+]|\d+\.)[ \t]+(?=\S))?[ \t]*(#{1,6}[ \t]+|```+[^`\n]*$|~~~+[^~\n]*$)?)?/gm
          while ((m = regexp.exec(text))) {
            matches.push(m)

            // Move regexp.lastIndex if the current match is empty
            if (m.index === regexp.lastIndex) {
              ++regexp.lastIndex
            }
          }

          matches.forEach(function(m) {
            var blockMarks = [],
              matchPos = m.index,
              matchLen = m[0].length,
              startPos,
              startLen,
              endPos,
              endLen

            ignoreLen = 0
            blockDepth = 0

            // If the last line was empty then this is not a continuation, and vice-versa
            continuation = !lineIsEmpty

            // Capture the position of the end of the line and determine whether the line is empty
            lfPos = text.indexOf('\n', matchPos)
            lineIsEmpty =
              lfPos === matchPos + matchLen && !m[3] && !m[4] && !m[5]

            // If the match is empty we need to move the cursor manually
            if (!matchLen) {
              ++regexp.lastIndex
            }

            // If the line is empty and it's the first empty line then we break current paragraph.
            breakParagraph = lineIsEmpty && continuation

            // Count block marks
            if (m[1]) {
              blockMarks = getBlockMarks(m[1])
              blockDepth = blockMarks.length
              ignoreLen = m[1].length
              if (codeTag && codeTag.hasAttribute('blockDepth')) {
                blockDepth = Math.min(
                  blockDepth,
                  codeTag.getAttribute('blockDepth'),
                )
                ignoreLen = computeBlockIgnoreLen(m[1], blockDepth)
              }

              // Overwrite block markup
              overwrite(matchPos, ignoreLen)
            }

            // Close supernumerary blocks
            if (blockDepth < blocksCnt && !continuation) {
              newContext = true
              do {
                var startTag = blocks.pop()
                addEndTag(startTag.getName(), textBoundary, 0).pairWith(
                  startTag,
                )
              } while (blockDepth < --blocksCnt)
            }

            // Open new blocks
            if (blockDepth > blocksCnt && !lineIsEmpty) {
              newContext = true
              do {
                var tagName =
                  blockMarks[blocksCnt] === '>!' ? 'SPOILER' : 'QUOTE'
                blocks.push(addStartTag(tagName, matchPos, 0, -999))
              } while (blockDepth > ++blocksCnt)
            }

            // Compute the width of the indentation
            var indentWidth = 0,
              indentPos = 0
            if (m[2] && !codeFence) {
              indentStr = m[2]
              indentLen = indentStr.length

              do {
                if (indentStr[indentPos] === ' ') {
                  ++indentWidth
                } else {
                  indentWidth = (indentWidth + 4) & ~3
                }
              } while (++indentPos < indentLen && indentWidth < codeIndent)
            }

            // Test whether we're out of a code block
            if (
              codeTag &&
              !codeFence &&
              indentWidth < codeIndent &&
              !lineIsEmpty
            ) {
              newContext = true
            }

            if (newContext) {
              newContext = false

              // Close the code block if applicable
              if (codeTag) {
                if (textBoundary > codeTag.getPos()) {
                  // Overwrite the whole block
                  overwrite(codeTag.getPos(), textBoundary - codeTag.getPos())
                  codeTag.pairWith(addEndTag('CODE', textBoundary, 0, -1))
                } else {
                  // The code block is empty
                  codeTag.invalidate()
                }
                codeTag = null
                codeFence = null
              }

              // Close all the lists
              lists.forEach(function(list) {
                closeList(list, textBoundary)
              })
              lists = []
              listsCnt = 0

              // Mark the block boundary
              if (matchPos) {
                markBoundary(matchPos - 1)
              }
            }

            if (indentWidth >= codeIndent) {
              if (codeTag || !continuation) {
                // Adjust the amount of text being ignored
                ignoreLen = (m[1] || '').length + indentPos

                if (!codeTag) {
                  // Create code block
                  codeTag = addStartTag('CODE', matchPos + ignoreLen, 0, -999)
                }

                // Clear the captures to prevent any further processing
                m = {}
              }
            } else {
              var hasListItem = !!m[4]

              if (!indentWidth && !continuation && !hasListItem) {
                // Start of a new context
                listIndex = -1
              } else if (continuation && !hasListItem) {
                // Continuation of current list item or paragraph
                listIndex = listsCnt - 1
              } else if (!listsCnt) {
                // We're not inside of a list already, we can start one if there's a list item
                listIndex = hasListItem ? 0 : -1
              } else {
                // We're inside of a list but we need to compute the depth
                listIndex = 0
                while (
                  listIndex < listsCnt &&
                  indentWidth > lists[listIndex].maxIndent
                ) {
                  ++listIndex
                }
              }

              // Close deeper lists
              while (listIndex < listsCnt - 1) {
                closeList(lists.pop(), textBoundary)
                --listsCnt
              }

              // If there's no list item at current index, we'll need to either create one or
              // drop down to previous index, in which case we have to adjust maxIndent
              if (listIndex === listsCnt && !hasListItem) {
                --listIndex
              }

              if (hasListItem && listIndex >= 0) {
                breakParagraph = true

                // Compute the position and amount of text consumed by the item tag
                tagPos = matchPos + ignoreLen + indentPos
                tagLen = m[4].length

                // Create a LI tag that consumes its markup
                var itemTag = addStartTag('LI', tagPos, tagLen)

                // Overwrite the markup
                overwrite(tagPos, tagLen)

                // If the list index is within current lists count it means this is not a new
                // list and we have to close the last item. Otherwise, it's a new list that we
                // have to create
                if (listIndex < listsCnt) {
                  addEndTag('LI', textBoundary, 0).pairWith(
                    lists[listIndex].itemTag,
                  )

                  // Record the item in the list
                  lists[listIndex].itemTag = itemTag
                  lists[listIndex].itemTags.push(itemTag)
                } else {
                  ++listsCnt

                  if (listIndex) {
                    minIndent = lists[listIndex - 1].maxIndent + 1
                    maxIndent = Math.max(minIndent, listIndex * 4)
                  } else {
                    minIndent = 0
                    maxIndent = indentWidth
                  }

                  // Create a 0-width LIST tag right before the item tag LI
                  var listTag = addStartTag('LIST', tagPos, 0)

                  // Test whether the list item ends with a dot, as in "1."
                  if (m[4].indexOf('.') > -1) {
                    listTag.setAttribute('type', 'decimal')

                    var start = +m[4]
                    if (start !== 1) {
                      listTag.setAttribute('start', start)
                    }
                  }

                  // Record the new list depth
                  lists.push({
                    listTag: listTag,
                    itemTag: itemTag,
                    itemTags: [itemTag],
                    minIndent: minIndent,
                    maxIndent: maxIndent,
                    tight: true,
                  })
                }
              }

              // If we're in a list, on a non-empty line preceded with a blank line...
              if (listsCnt && !continuation && !lineIsEmpty) {
                // ...and this is not the first item of the list...
                if (lists[0].itemTags.length > 1 || !hasListItem) {
                  // ...every list that is currently open becomes loose
                  lists.forEach(function(list) {
                    list.tight = false
                  })
                }
              }

              codeIndent = (listsCnt + 1) * 4
            }

            if (m[5]) {
              // Headers
              if (m[5][0] === '#') {
                startLen = m[5].length
                startPos = matchPos + matchLen - startLen
                endLen = getAtxHeaderEndTagLen(matchPos + matchLen, lfPos)
                endPos = lfPos - endLen

                addTagPair(
                  'H' + /#{1,6}/.exec(m[5])[0].length,
                  startPos,
                  startLen,
                  endPos,
                  endLen,
                )

                // Mark the start and the end of the header as boundaries
                markBoundary(startPos)
                markBoundary(lfPos)

                if (continuation) {
                  breakParagraph = true
                }
              }
              // Code fence
              else if (m[5][0] === '`' || m[5][0] === '~') {
                tagPos = matchPos + ignoreLen
                tagLen = lfPos - tagPos

                if (codeTag && m[5] === codeFence) {
                  codeTag.pairWith(addEndTag('CODE', tagPos, tagLen, -1))
                  addIgnoreTag(textBoundary, tagPos - textBoundary)

                  // Overwrite the whole block
                  overwrite(
                    codeTag.getPos(),
                    tagPos + tagLen - codeTag.getPos(),
                  )
                  codeTag = null
                  codeFence = null
                } else if (!codeTag) {
                  // Create code block
                  codeTag = addStartTag('CODE', tagPos, tagLen)
                  codeFence = m[5].replace(/[^`~]+/, '')
                  codeTag.setAttribute('blockDepth', blockDepth)

                  // Ignore the next character, which should be a newline
                  addIgnoreTag(tagPos + tagLen, 1)

                  // Add the language if present, e.g. ```php
                  var lang = m[5].replace(/^[`~\s]*/, '').replace(/\s+$/, '')
                  if (lang !== '') {
                    codeTag.setAttribute('lang', lang)
                  }
                }
              }
            } else if (
              m[3] &&
              !listsCnt &&
              text[matchPos + matchLen] !== '\x17'
            ) {
              // Horizontal rule
              addSelfClosingTag(
                'HR',
                matchPos + ignoreLen,
                matchLen - ignoreLen,
              )
              breakParagraph = true

              // Mark the end of the line as a boundary
              markBoundary(lfPos)
            } else if (
              setextLines[lfPos] &&
              setextLines[lfPos].blockDepth === blockDepth &&
              !lineIsEmpty &&
              !listsCnt &&
              !codeTag
            ) {
              // Setext-style header
              addTagPair(
                setextLines[lfPos].tagName,
                matchPos + ignoreLen,
                0,
                setextLines[lfPos].endPos,
                setextLines[lfPos].endLen,
              )

              // Mark the end of the Setext line
              markBoundary(
                setextLines[lfPos].endPos + setextLines[lfPos].endLen,
              )
            }

            if (breakParagraph) {
              addParagraphBreak(textBoundary)
              markBoundary(textBoundary)
            }

            if (!lineIsEmpty) {
              textBoundary = lfPos
            }

            if (ignoreLen) {
              addIgnoreTag(matchPos, ignoreLen, 1000)
            }
          })
        }

        /**
         * Close a list at given offset
         *
         * @param {!Object} list
         * @param {number}  textBoundary
         */
        function closeList(list, textBoundary) {
          addEndTag('LIST', textBoundary, 0).pairWith(list.listTag)
          addEndTag('LI', textBoundary, 0).pairWith(list.itemTag)

          if (list.tight) {
            list.itemTags.forEach(function(itemTag) {
              itemTag.removeFlags(RULE_CREATE_PARAGRAPHS)
            })
          }
        }

        /**
         * Compute the amount of text to ignore at the start of a block line
         *
         * @param  {string} str           Original block markup
         * @param  {number} maxBlockDepth Maximum block depth
         * @return {number}               Number of characters to ignore
         */
        function computeBlockIgnoreLen(str, maxBlockDepth) {
          var remaining = str
          while (--maxBlockDepth >= 0) {
            remaining = remaining.replace(/^ *>!? ?/, '')
          }

          return str.length - remaining.length
        }

        /**
         * Return the length of the markup at the end of an ATX header
         *
         * @param  {number} startPos Start of the header's text
         * @param  {number} endPos   End of the header's text
         * @return {number}
         */
        function getAtxHeaderEndTagLen(startPos, endPos) {
          var content = text.substr(startPos, endPos - startPos),
            m = /[ \t]*#*[ \t]*$/.exec(content)

          return m[0].length
        }

        /**
         * Capture and return block marks from given string
         *
         * @param  {string} str Block markup, composed of ">", "!" and whitespace
         * @return {!Array<string>}
         */
        function getBlockMarks(str) {
          var blockMarks = [],
            regexp = />!?/g,
            m
          while ((m = regexp.exec(str))) {
            blockMarks.push(m[0])
          }

          return blockMarks
        }

        /**
         * Capture and store lines that contain a Setext-tyle header
         */
        function matchSetextLines() {
          // Capture the underlines used for Setext-style headers
          if (text.indexOf('-') === -1 && text.indexOf('=') === -1) {
            return
          }

          // Capture the any series of - or = alone on a line, optionally preceded with the
          // angle brackets notation used in block markup
          var m,
            regexp = /^(?=[-=>])(?:>!? ?)*(?=[-=])(?:-+|=+) *$/gm

          while ((m = regexp.exec(text))) {
            var match = m[0],
              matchPos = m.index

            // Compute the position of the end tag. We start on the LF character before the
            // match and keep rewinding until we find a non-space character
            var endPos = matchPos - 1
            while (endPos > 0 && text[endPos - 1] === ' ') {
              --endPos
            }

            // Store at the offset of the LF character
            setextLines[matchPos - 1] = {
              endLen: matchPos + match.length - endPos,
              endPos: endPos,
              blockDepth: match.length - match.replace(/>/g, '').length,
              tagName: match[0] === '=' ? 'H1' : 'H2',
            }
          }
        }
        parse()
      })()
      ;(function() {
        function parse() {
          if (text.indexOf(']:') < 0) {
            return
          }

          var m,
            regexp = /^\x1A* {0,3}\[([^\x17\]]+)\]: *([^[\s\x17]+ *(?:"[^\x17]*?"|'[^\x17]*?'|\([^\x17)]*\))?) *(?=$|\x17)\n?/gm
          while ((m = regexp.exec(text))) {
            addIgnoreTag(m.index, m[0].length)

            // Only add the reference if it does not already exist
            var id = m[1].toLowerCase()
            if (!linkReferences[id]) {
              hasReferences = true
              linkReferences[id] = m[2]
            }
          }
        }
        parse()
      })()
      ;(function() {
        function parse() {
          var markers = getInlineCodeMarkers(),
            i = -1,
            cnt = markers.length
          while (++i < cnt - 1) {
            var pos = markers[i].next,
              j = i
            if (text[markers[i].pos] !== '`') {
              // Adjust the left marker if its first backtick was escaped
              ++markers[i].pos
              --markers[i].len
            }
            while (++j < cnt && markers[j].pos === pos) {
              if (markers[j].len === markers[i].len) {
                addInlineCodeTags(markers[i], markers[j])
                i = j
                break
              }
              pos = markers[j].next
            }
          }
        }

        /**
         * Add the tag pair for an inline code span
         *
         * @param {!Object} left  Left marker
         * @param {!Object} right Right marker
         */
        function addInlineCodeTags(left, right) {
          var startPos = left.pos,
            startLen = left.len + left.trimAfter,
            endPos = right.pos - right.trimBefore,
            endLen = right.len + right.trimBefore
          addTagPair('C', startPos, startLen, endPos, endLen)
          overwrite(startPos, endPos + endLen - startPos)
        }

        /**
         * Capture and return inline code markers
         *
         * @return {!Array<!Object>}
         */
        function getInlineCodeMarkers() {
          var pos = text.indexOf('`')
          if (pos < 0) {
            return []
          }

          var regexp = /(`+)(\s*)[^\x17`]*/g,
            trimNext = 0,
            markers = [],
            _text = text.replace(/\x1BB/g, '\\`'),
            m
          regexp.lastIndex = pos
          while ((m = regexp.exec(_text))) {
            markers.push({
              pos: m.index,
              len: m[1].length,
              trimBefore: trimNext,
              trimAfter: m[2].length,
              next: m.index + m[0].length,
            })
            trimNext = m[0].length - m[0].replace(/\s+$/, '').length
          }

          return markers
        }
        parse()
      })()
      ;(function() {
        function parse() {
          var pos = text.indexOf('![')
          if (pos === -1) {
            return
          }
          if (text.indexOf('](', pos) > 0) {
            parseInlineImages()
          }
          if (hasReferences) {
            parseReferenceImages()
          }
        }

        /**
         * Add an image tag for given text span
         *
         * @param {number} startPos Start tag position
         * @param {number} endPos   End tag position
         * @param {number} endLen   End tag length
         * @param {string} linkInfo URL optionally followed by space and a title
         * @param {string} alt      Value for the alt attribute
         */
        function addImageTag(startPos, endPos, endLen, linkInfo, alt) {
          var tag = addTagPair('IMG', startPos, 2, endPos, endLen)
          setLinkAttributes(tag, linkInfo, 'src')
          tag.setAttribute('alt', decode(alt))

          // Overwrite the markup
          overwrite(startPos, endPos + endLen - startPos)
        }

        /**
         * Parse inline images markup
         */
        function parseInlineImages() {
          var m,
            regexp = /!\[(?:[^\x17[\]]|\[[^\x17[\]]*\])*\]\(( *(?:[^\x17\s()]|\([^\x17\s()]*\))*(?=[ )]) *(?:"[^\x17]*?"|'[^\x17]*?'|\([^\x17)]*\))? *)\)/g
          while ((m = regexp.exec(text))) {
            var linkInfo = m[1],
              startPos = m.index,
              endLen = 3 + linkInfo.length,
              endPos = startPos + m[0].length - endLen,
              alt = m[0].substr(2, m[0].length - endLen - 2)

            addImageTag(startPos, endPos, endLen, linkInfo, alt)
          }
        }

        /**
         * Parse reference images markup
         */
        function parseReferenceImages() {
          var m,
            regexp = /!\[((?:[^\x17[\]]|\[[^\x17[\]]*\])*)\](?: ?\[([^\x17[\]]+)\])?/g
          while ((m = regexp.exec(text))) {
            var startPos = m.index,
              endPos = startPos + 2 + m[1].length,
              endLen = 1,
              alt = m[1],
              id = alt

            if (m[2] > '' && linkReferences[m[2]]) {
              endLen = m[0].length - alt.length - 2
              id = m[2]
            } else if (!linkReferences[id]) {
              continue
            }

            addImageTag(startPos, endPos, endLen, linkReferences[id], alt)
          }
        }
        parse()
      })()
      ;(function() {
        function parse() {
          parseInlineMarkup('>!', />![^\x17]+?!</g, 'ISPOILER')
          parseInlineMarkup('||', /\|\|[^\x17]+?\|\|/g, 'ISPOILER')
        }
        parse()
      })()
      ;(function() {
        function parse() {
          if (text.indexOf('](') !== -1) {
            parseInlineLinks()
          }
          if (hasReferences) {
            parseReferenceLinks()
          }
        }

        /**
         * Add an image tag for given text span
         *
         * @param {number} startPos Start tag position
         * @param {number} endPos   End tag position
         * @param {number} endLen   End tag length
         * @param {string} linkInfo URL optionally followed by space and a title
         */
        function addLinkTag(startPos, endPos, endLen, linkInfo) {
          // Give the link a slightly worse priority if this is a implicit reference and a slightly
          // better priority if it's an explicit reference or an inline link or to give it precedence
          // over possible BBCodes such as [b](https://en.wikipedia.org/wiki/B)
          var priority = endLen === 1 ? 1 : -1

          var tag = addTagPair('URL', startPos, 1, endPos, endLen, priority)
          setLinkAttributes(tag, linkInfo, 'url')

          // Overwrite the markup without touching the link's text
          overwrite(startPos, 1)
          overwrite(endPos, endLen)
        }

        /**
         * Capture and return labels used in current text
         *
         * @return {!Object} Labels' text position as keys, lowercased text content as values
         */
        function getLabels() {
          var labels = {},
            m,
            regexp = /\[((?:[^\x17[\]]|\[[^\x17[\]]*\])*)\]/g
          while ((m = regexp.exec(text))) {
            labels[m.index] = m[1].toLowerCase()
          }

          return labels
        }

        /**
         * Parse inline links markup
         */
        function parseInlineLinks() {
          var m,
            regexp = /\[(?:[^\x17[\]]|\[[^\x17[\]]*\])*\]\(( *(?:[^\x17\s()]|\([^\x17\s()]*\))*(?=[ )]) *(?:"[^\x17]*?"|'[^\x17]*?'|\([^\x17)]*\))? *)\)/g
          while ((m = regexp.exec(text))) {
            var linkInfo = m[1],
              startPos = m.index,
              endLen = 3 + linkInfo.length,
              endPos = startPos + m[0].length - endLen

            addLinkTag(startPos, endPos, endLen, linkInfo)
          }
        }

        /**
         * Parse reference links markup
         */
        function parseReferenceLinks() {
          var labels = getLabels(),
            startPos
          for (startPos in labels) {
            var id = labels[startPos],
              labelPos = +startPos + 2 + id.length,
              endPos = labelPos - 1,
              endLen = 1

            if (text[labelPos] === ' ') {
              ++labelPos
            }
            if (labels[labelPos] > '' && linkReferences[labels[labelPos]]) {
              id = labels[labelPos]
              endLen = labelPos + 2 + id.length - endPos
            }
            if (linkReferences[id]) {
              addLinkTag(+startPos, endPos, endLen, linkReferences[id])
            }
          }
        }

        parse()
      })()
      ;(function() {
        function parse() {
          parseInlineMarkup('~~', /~~[^\x17]+?~~(?!~)/g, 'DEL')
        }
        parse()
      })()
      ;(function() {
        function parse() {
          parseAbstractScript(
            'SUB',
            '~',
            /~[^\x17\s!"#$%&\'()*+,\-.\/:;<=>?@[\]^_`{}|~]+~?/g,
            /~\([^\x17()]+\)/g,
          )
        }
        parse()
      })()
      ;(function() {
        function parse() {
          parseAbstractScript(
            'SUP',
            '^',
            /\^[^\x17\s!"#$%&\'()*+,\-.\/:;<=>?@[\]^_`{}|~]+\^?/g,
            /\^\([^\x17()]+\)/g,
          )
        }
        parse()
      })()
      ;(function() {
        /**
         * @type {boolean} Whether current EM span is being closed by current emphasis mark
         */
        var closeEm

        /**
         * @type {boolean} Whether current EM span is being closed by current emphasis mark
         */
        var closeStrong

        /**
         * @type {number} Starting position of the current EM span in the text
         */
        var emPos

        /**
         * @type {number} Ending position of the current EM span in the text
         */
        var emEndPos

        /**
         * @type {number} Number of emphasis characters unused in current span
         */
        var remaining

        /**
         * @type {number} Starting position of the current STRONG span in the text
         */
        var strongPos

        /**
         * @type {number} Ending position of the current STRONG span in the text
         */
        var strongEndPos

        function parse() {
          parseEmphasisByCharacter('*', /\*+/g)
          parseEmphasisByCharacter('_', /_+/g)
        }

        /**
         * Adjust the ending position of current EM and STRONG spans
         */
        function adjustEndingPositions() {
          if (closeEm && closeStrong) {
            if (emPos < strongPos) {
              emEndPos += 2
            } else {
              ++strongEndPos
            }
          }
        }

        /**
         * Adjust the starting position of current EM and STRONG spans
         *
         * If both EM and STRONG are set to start at the same position, we adjust their position
         * to match the order they are closed. If they start and end at the same position, STRONG
         * starts before EM to match Markdown's behaviour
         */
        function adjustStartingPositions() {
          if (emPos >= 0 && emPos === strongPos) {
            if (closeEm) {
              emPos += 2
            } else {
              ++strongPos
            }
          }
        }

        /**
         * End current valid EM and STRONG spans
         */
        function closeSpans() {
          if (closeEm) {
            --remaining
            addTagPair('EM', emPos, 1, emEndPos, 1)
            emPos = -1
          }
          if (closeStrong) {
            remaining -= 2
            addTagPair('STRONG', strongPos, 2, strongEndPos, 2)
            strongPos = -1
          }
        }

        /**
         * Get emphasis markup split by block
         *
         * @param  {!RegExp} regexp Regexp used to match emphasis
         * @param  {number}  pos    Position in the text of the first emphasis character
         * @return {!Array}         Each array contains a list of [matchPos, matchLen] pairs
         */
        function getEmphasisByBlock(regexp, pos) {
          var block = [],
            blocks = [],
            breakPos = text.indexOf('\x17', pos),
            m

          regexp.lastIndex = pos
          while ((m = regexp.exec(text))) {
            var matchPos = m.index,
              matchLen = m[0].length

            // Test whether we've just passed the limits of a block
            if (matchPos > breakPos) {
              blocks.push(block)
              block = []
              breakPos = text.indexOf('\x17', matchPos)
            }

            // Test whether we should ignore this markup
            if (!ignoreEmphasis(matchPos, matchLen)) {
              block.push([matchPos, matchLen])
            }
          }
          blocks.push(block)

          return blocks
        }

        /**
         * Test whether emphasis should be ignored at the given position in the text
         *
         * @param  {number}  pos Position of the emphasis in the text
         * @param  {number}  len Length of the emphasis
         * @return {boolean}
         */
        function ignoreEmphasis(pos, len) {
          // Ignore single underscores between alphanumeric characters
          return (
            text.charAt(pos) === '_' &&
            len === 1 &&
            isSurroundedByAlnum(pos, len)
          )
        }

        /**
         * Open EM and STRONG spans whose content starts at given position
         *
         * @param {number} pos
         */
        function openSpans(pos) {
          if (remaining & 1) {
            emPos = pos - remaining
          }
          if (remaining & 2) {
            strongPos = pos - remaining
          }
        }

        /**
         * Parse emphasis and strong applied using given character
         *
         * @param  {string} character Markup character, either * or _
         * @param  {!RegExp} regexp    Regexp used to match the series of emphasis character
         */
        function parseEmphasisByCharacter(character, regexp) {
          var pos = text.indexOf(character)
          if (pos === -1) {
            return
          }

          getEmphasisByBlock(regexp, pos).forEach(processEmphasisBlock)
        }

        /**
         * Process a list of emphasis markup strings
         *
         * @param {!Array<!Array<number>>} block List of [matchPos, matchLen] pairs
         */
        function processEmphasisBlock(block) {
          ;(emPos = -1), (strongPos = -1)

          block.forEach(function(pair) {
            processEmphasisMatch(pair[0], pair[1])
          })
        }

        /**
         * Process an emphasis mark
         *
         * @param {number} matchPos
         * @param {number} matchLen
         */
        function processEmphasisMatch(matchPos, matchLen) {
          var canOpen = !isBeforeWhitespace(matchPos + matchLen - 1),
            canClose = !isAfterWhitespace(matchPos),
            closeLen = canClose ? Math.min(matchLen, 3) : 0

          closeEm = !!(closeLen & 1) && emPos >= 0
          closeStrong = !!(closeLen & 2) && strongPos >= 0
          emEndPos = matchPos
          strongEndPos = matchPos
          remaining = matchLen

          adjustStartingPositions()
          adjustEndingPositions()
          closeSpans()

          // Adjust the length of unused markup remaining in current match
          remaining = canOpen ? Math.min(remaining, 3) : 0
          openSpans(matchPos + matchLen)
        }
        parse()
      })()
      ;(function() {
        function parse() {
          var pos = text.indexOf('  \n')
          while (pos > 0) {
            addBrTag(pos + 2).cascadeInvalidationTo(addVerbatim(pos + 2, 1))
            pos = text.indexOf('  \n', pos + 3)
          }
        }
        parse()
      })()
    },
  },
  Preg: {
    /**
     * @param {string}          text
     * @param {!Array.<!Array>} matches
     */
    parser: function(text, matches) {
      /** @const */
      var config = {
        generics: [
          ['USERMENTION', /\B@([a-z0-9_-]+)(?!#)/gi, 0, ['', 'username']],
          [
            'POSTMENTION',
            /\B@([a-z0-9_-]+)#(\d+)/gi,
            0,
            ['', 'username', 'id'],
          ],
        ],
      }
      config.generics.forEach(function(entry) {
        var tagName = entry[0],
          regexp = entry[1],
          passthroughIdx = entry[2],
          map = entry[3],
          m

        // Reset the regexp
        regexp.lastIndex = 0

        while ((m = regexp.exec(text))) {
          var startTagPos = m.index,
            matchLen = m[0].length,
            tag

          if (
            HINT.PREG_HAS_PASSTHROUGH &&
            passthroughIdx &&
            m[passthroughIdx] !== ''
          ) {
            // Compute the position and length of the start tag, end tag, and the content in
            // between. m.index gives us the position of the start tag but we don't know its length.
            // We use indexOf() to locate the content part so that we know how long the start tag
            // is. It is an imperfect solution but it should work well enough in most cases.
            var contentPos = text.indexOf(m[passthroughIdx], startTagPos),
              contentLen = m[passthroughIdx].length,
              startTagLen = contentPos - startTagPos,
              endTagPos = contentPos + contentLen,
              endTagLen = matchLen - (startTagLen + contentLen)

            tag = addTagPair(
              tagName,
              startTagPos,
              startTagLen,
              endTagPos,
              endTagLen,
              -100,
            )
          } else {
            tag = addSelfClosingTag(tagName, startTagPos, matchLen, -100)
          }

          map.forEach(function(attrName, i) {
            // NOTE: subpatterns with no name have an empty entry to preserve the array indices
            if (attrName && typeof m[i] !== 'undefined') {
              tag.setAttribute(attrName, m[i])
            }
          })
        }
      })
    },
  },
}

/**
 * @type {number} Position of the cursor in the original text
 */
var pos

/**
 * @type {!Object} Variables registered for use in filters
 */
var registeredVars = { urlConfig: { allowedSchemes: /^https?$/i } }

/**
 * @type {!Object} Root context, used at the root of the document
 */
var rootContext = { allowed: oF6AF222C, flags: 40 }

/**
 * @type {!Object} Tags' config
 * @const
 */
var tagsConfig = {
  B: o5B6ED7AA,
  C: {
    allowed: o553403F9,
    attributes: {},
    bitNumber: 2,
    filterChain: o1B4F5B52,
    nestingLimit: 10,
    rules: { flags: 66 },
    tagLimit: 5000,
  },
  CENTER: {
    allowed: oF6AF222C,
    attributes: {},
    bitNumber: 3,
    filterChain: o1B4F5B52,
    nestingLimit: 10,
    rules: o1AF69066,
    tagLimit: 5000,
  },
  CODE: {
    allowed: o553403F9,
    attributes: { lang: { filterChain: o56E79363, required: !1 } },
    bitNumber: 3,
    filterChain: o1B4F5B52,
    nestingLimit: 10,
    rules: { closeParent: oD4869BFF, flags: 4436, fosterParent: oD4869BFF },
    tagLimit: 5000,
  },
  COLOR: {
    allowed: oD363F9C5,
    attributes: {
      color: {
        filterChain: [
          /**
           * @param {*} attrValue
           * @param {string} attrName
           * @return {*}
           */
          function(attrValue, attrName) {
            return RegexpFilter.filter(
              attrValue,
              /^(?:#(?:(?:[0-9a-f]{3}){1,2}|(?:[0-9a-f]{4}){1,2})|rgb\(\d{1,3}, *\d{1,3}, *\d{1,3}\)|rgba\(\d{1,3}, *\d{1,3}, *\d{1,3}, *\d*(?:\.\d+)?\)|[a-z]+)$/i,
            )
          },
        ],
        required: !0,
      },
    },
    bitNumber: 2,
    filterChain: o1B4F5B52,
    nestingLimit: 10,
    rules: oB565876D,
    tagLimit: 5000,
  },
  DEL: {
    allowed: oF6AF222C,
    attributes: {},
    bitNumber: 2,
    filterChain: o1B4F5B52,
    nestingLimit: 10,
    rules: { flags: 512 },
    tagLimit: 5000,
  },
  E: {
    allowed: oC06C5BF5,
    attributes: {},
    bitNumber: 5,
    filterChain: o1B4F5B52,
    nestingLimit: 10,
    rules: oA80287CC,
    tagLimit: 5000,
  },
  EM: o5B6ED7AA,
  EMAIL: {
    allowed: o3C789569,
    attributes: {
      email: {
        filterChain: [
          /**
           * @param {*} attrValue
           * @param {string} attrName
           * @return {*}
           */
          function(attrValue, attrName) {
            return EmailFilter.filter(attrValue)
          },
        ],
        required: !0,
      },
    },
    bitNumber: 1,
    filterChain: o1B4F5B52,
    nestingLimit: 10,
    rules: o939F1698,
    tagLimit: 5000,
  },
  ESC: {
    allowed: o553403F9,
    attributes: {},
    bitNumber: 0,
    filterChain: o1B4F5B52,
    nestingLimit: 10,
    rules: { flags: 1616 },
    tagLimit: 5000,
  },
  H1: oE13673F5,
  H2: oE13673F5,
  H3: oE13673F5,
  H4: oE13673F5,
  H5: oE13673F5,
  H6: oE13673F5,
  HR: {
    allowed: oC06C5BF5,
    attributes: {},
    bitNumber: 3,
    filterChain: o1B4F5B52,
    nestingLimit: 10,
    rules: oF3C6FA42,
    tagLimit: 5000,
  },
  I: o5B6ED7AA,
  IMG: {
    allowed: oC06C5BF5,
    attributes: {
      alt: o1BC3EAF4,
      height: o75AB9259,
      src: oF307D35C,
      title: o1BC3EAF4,
      width: o75AB9259,
    },
    bitNumber: 2,
    filterChain: o1B4F5B52,
    nestingLimit: 10,
    rules: oA80287CC,
    tagLimit: 5000,
  },
  ISPOILER: o8F52476D,
  LI: {
    allowed: oF6AF222C,
    attributes: {},
    bitNumber: 4,
    filterChain: o1B4F5B52,
    nestingLimit: 10,
    rules: {
      closeParent: {
        B: 1,
        C: 1,
        COLOR: 1,
        EM: 1,
        EMAIL: 1,
        I: 1,
        LI: 1,
        S: 1,
        SIZE: 1,
        STRONG: 1,
        U: 1,
        URL: 1,
      },
      flags: 264,
      fosterParent: oD4869BFF,
    },
    tagLimit: 5000,
  },
  LIST: {
    allowed: [32529],
    attributes: {
      start: o75AB9259,
      type: {
        filterChain: [
          /**
           * @param {*} attrValue
           * @param {string} attrName
           * @return {*}
           */
          function(attrValue, attrName) {
            return HashmapFilter.filter(
              attrValue,
              {
                A: 'upper-alpha',
                I: 'upper-roman',
                a: 'lower-alpha',
                i: 'lower-roman',
                '1': 'decimal',
              },
              !1,
            )
          },
          o6377B813,
        ],
        required: !1,
      },
    },
    bitNumber: 3,
    filterChain: o1B4F5B52,
    nestingLimit: 10,
    rules: {
      closeParent: oD4869BFF,
      createChild: ['LI'],
      flags: 3460,
      fosterParent: oD4869BFF,
    },
    tagLimit: 5000,
  },
  POSTMENTION: {
    allowed: oC06C5BF5,
    attributes: {
      discussionid: o6CB0A318,
      displayname: o02D8DBB5,
      id: o6CB0A318,
      number: o6CB0A318,
      username: o02D8DBB5,
    },
    bitNumber: 1,
    filterChain: [
      /**
       * @param {!Tag} tag
       * @param {!Object} tagConfig
       * @return {*}
       */
      function(tag, tagConfig) {
        return (function(tag) {
          return flarum.extensions['flarum-mentions'].filterPostMentions(tag)
        })(tag)
      },
      o118B31AC,
    ],
    nestingLimit: 10,
    rules: oA80287CC,
    tagLimit: 5000,
  },
  QUOTE: {
    allowed: oF6AF222C,
    attributes: { author: o1BC3EAF4 },
    bitNumber: 3,
    filterChain: o1B4F5B52,
    nestingLimit: 10,
    rules: o1AF69066,
    tagLimit: 5000,
  },
  S: o5B6ED7AA,
  SIZE: {
    allowed: oD363F9C5,
    attributes: {
      size: {
        filterChain: [
          /**
           * @param {*} attrValue
           * @param {string} attrName
           * @return {*}
           */
          function(attrValue, attrName) {
            return NumericFilter.filterRange(attrValue, 8, 36, logger)
          },
        ],
        required: !0,
      },
    },
    bitNumber: 2,
    filterChain: o1B4F5B52,
    nestingLimit: 10,
    rules: oB565876D,
    tagLimit: 5000,
  },
  SPOILER: {
    allowed: oF6AF222C,
    attributes: {},
    bitNumber: 6,
    filterChain: o1B4F5B52,
    nestingLimit: 10,
    rules: o1AF69066,
    tagLimit: 5000,
  },
  STRONG: o5B6ED7AA,
  SUB: o8F52476D,
  SUP: o8F52476D,
  U: o5B6ED7AA,
  'UPL-FILE': {
    allowed: oC06C5BF5,
    attributes: { content: oABCFC4A3, size: oABCFC4A3, uuid: oE2346708 },
    bitNumber: 3,
    filterChain: o1B4F5B52,
    nestingLimit: 10,
    rules: oF3C6FA42,
    tagLimit: 5000,
  },
  'UPL-IMAGE': {
    allowed: oC06C5BF5,
    attributes: {
      content: oABCFC4A3,
      size: oABCFC4A3,
      url: oF307D35C,
      uuid: oE2346708,
    },
    bitNumber: 3,
    filterChain: o1B4F5B52,
    nestingLimit: 10,
    rules: oF3C6FA42,
    tagLimit: 5000,
  },
  'UPL-IMAGE-PREVIEW': {
    allowed: oC06C5BF5,
    attributes: { url: oF307D35C },
    bitNumber: 2,
    filterChain: o1B4F5B52,
    nestingLimit: 10,
    rules: oA80287CC,
    tagLimit: 5000,
  },
  URL: {
    allowed: o3C789569,
    attributes: { title: o1BC3EAF4, url: oF307D35C },
    bitNumber: 1,
    filterChain: o1B4F5B52,
    nestingLimit: 10,
    rules: o939F1698,
    tagLimit: 5000,
  },
  USERMENTION: {
    allowed: oC06C5BF5,
    attributes: {
      displayname: o02D8DBB5,
      id: o6CB0A318,
      username: o02D8DBB5,
    },
    bitNumber: 1,
    filterChain: [
      /**
       * @param {!Tag} tag
       * @param {!Object} tagConfig
       * @return {*}
       */
      function(tag, tagConfig) {
        return (function(tag) {
          return flarum.extensions['flarum-mentions'].filterUserMentions(tag)
        })(tag)
      },
      o118B31AC,
    ],
    nestingLimit: 10,
    rules: oA80287CC,
    tagLimit: 5000,
  },
}

/**
 * @type {!Array.<!Tag>} Tag storage
 */
var tagStack

/**
 * @type {boolean} Whether the tags in the stack are sorted
 */
var tagStackIsSorted

/**
 * @type {string} Text being parsed
 */
var text

/**
 * @type {number} Length of the text being parsed
 */
var textLen

/**
 * @type {number} Counter incremented everytime the parser is reset. Used to as a canary to detect
 *                 whether the parser was reset during execution
 */
var uid = 0

/**
 * @type {number} Position before which we output text verbatim, without paragraphs or linebreaks
 */
var wsPos

//==========================================================================
// Public API
//==========================================================================

/**
 * Disable a tag
 *
 * @param {string} tagName Name of the tag
 */
function disableTag(tagName) {
  if (tagsConfig[tagName]) {
    copyTagConfig(tagName).isDisabled = true
  }
}

/**
 * Enable a tag
 *
 * @param {string} tagName Name of the tag
 */
function enableTag(tagName) {
  if (tagsConfig[tagName]) {
    copyTagConfig(tagName).isDisabled = false
  }
}

/**
 * Get this parser's Logger instance
 *
 * @return {!Logger}
 */
function getLogger() {
  return logger
}

/**
 * Parse a text
 *
 * @param  {string} _text Text to parse
 * @return {string}       XML representation
 */
function parse(_text) {
  // Reset the parser and save the uid
  reset(_text)
  var _uid = uid

  // Do the heavy lifting
  executePluginParsers()
  processTags()

  // Finalize the document
  finalizeOutput()

  // Check the uid in case a plugin or a filter reset the parser mid-execution
  if (uid !== _uid) {
    throw 'The parser has been reset during execution'
  }

  // Log a warning if the fixing cost limit was exceeded
  if (currentFixingCost > maxFixingCost) {
    logger.warn('Fixing cost limit exceeded')
  }

  return output
}

/**
 * Reset the parser for a new parsing
 *
 * @param {string} _text Text to be parsed
 */
function reset(_text) {
  // Normalize CR/CRLF to LF, remove control characters that aren't allowed in XML
  _text = _text.replace(/\r\n?/g, '\n')
  _text = _text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F]+/g, '')

  // Clear the logs
  logger.clear()

  // Initialize the rest
  cntOpen = {}
  cntTotal = {}
  currentFixingCost = 0
  currentTag = null
  isRich = false
  namespaces = {}
  openTags = []
  output = ''
  pos = 0
  tagStack = []
  tagStackIsSorted = false
  text = _text
  textLen = text.length
  wsPos = 0

  // Initialize the root context
  context = rootContext
  context.inParagraph = false

  // Bump the UID
  ++uid
}

/**
 * Change a tag's tagLimit
 *
 * NOTE: the default tagLimit should generally be set during configuration instead
 *
 * @param {string} tagName  The tag's name, in UPPERCASE
 * @param {number} tagLimit
 */
function setTagLimit(tagName, tagLimit) {
  if (tagsConfig[tagName]) {
    copyTagConfig(tagName).tagLimit = tagLimit
  }
}

/**
 * Change a tag's nestingLimit
 *
 * NOTE: the default nestingLimit should generally be set during configuration instead
 *
 * @param {string} tagName      The tag's name, in UPPERCASE
 * @param {number} nestingLimit
 */
function setNestingLimit(tagName, nestingLimit) {
  if (tagsConfig[tagName]) {
    copyTagConfig(tagName).nestingLimit = nestingLimit
  }
}

/**
 * Copy a tag's config
 *
 * This method ensures that the tag's config is its own object and not shared with another
 * identical tag
 *
 * @param  {string} tagName Tag's name
 * @return {!Object}         Tag's config
 */
function copyTagConfig(tagName) {
  var tagConfig = {},
    k
  for (k in tagsConfig[tagName]) {
    tagConfig[k] = tagsConfig[tagName][k]
  }

  return (tagsConfig[tagName] = tagConfig)
}

//==========================================================================
// Output handling
//==========================================================================

/**
 * Replace Unicode characters outside the BMP with XML entities in the output
 */
function encodeUnicodeSupplementaryCharacters() {
  output = output.replace(
    /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
    encodeUnicodeSupplementaryCharactersCallback,
  )
}

/**
 * Encode given surrogate pair into an XML entity
 *
 * @param  {string} pair Surrogate pair
 * @return {string}      XML entity
 */
function encodeUnicodeSupplementaryCharactersCallback(pair) {
  var cp = (pair.charCodeAt(0) << 10) + pair.charCodeAt(1) - 56613888

  return '&#' + cp + ';'
}

/**
 * Finalize the output by appending the rest of the unprocessed text and create the root node
 */
function finalizeOutput() {
  var tmp

  // Output the rest of the text and close the last paragraph
  outputText(textLen, 0, true)

  // Remove empty tag pairs, e.g. <I><U></U></I> as well as empty paragraphs
  do {
    tmp = output
    output = output.replace(/<([^ />]+)[^>]*><\/\1>/g, '')
  } while (output !== tmp)

  // Merge consecutive <i> tags
  output = output.replace(/<\/i><i>/g, '')

  // Remove control characters from the output to ensure it's valid XML
  output = output.replace(/[\x00-\x08\x0B-\x1F]/g, '')

  // Encode Unicode characters that are outside of the BMP
  encodeUnicodeSupplementaryCharacters()

  // Use a <r> root if the text is rich, or <t> for plain text (including <p></p> and <br/>)
  var tagName = isRich ? 'r' : 't'

  // Prepare the root node with all the namespace declarations
  tmp = '<' + tagName
  if (HINT.namespaces) {
    for (var prefix in namespaces) {
      tmp += ' xmlns:' + prefix + '="urn:s9e:TextFormatter:' + prefix + '"'
    }
  }

  output = tmp + '>' + output + '</' + tagName + '>'
}

/**
 * Append a tag to the output
 *
 * @param {!Tag} tag Tag to append
 */
function outputTag(tag) {
  isRich = true

  var tagName = tag.getName(),
    tagPos = tag.getPos(),
    tagLen = tag.getLen(),
    tagFlags = tag.getFlags(),
    skipBefore = 0,
    skipAfter = 0

  if (HINT.RULE_IGNORE_WHITESPACE && tagFlags & RULE_IGNORE_WHITESPACE) {
    skipBefore = 1
    skipAfter = tag.isEndTag() ? 2 : 1
  }

  // Current paragraph must end before the tag if:
  //  - the tag is a start (or self-closing) tag and it breaks paragraphs, or
  //  - the tag is an end tag (but not self-closing)
  var closeParagraph = false
  if (tag.isStartTag()) {
    if (HINT.RULE_BREAK_PARAGRAPH && tagFlags & RULE_BREAK_PARAGRAPH) {
      closeParagraph = true
    }
  } else {
    closeParagraph = true
  }

  // Let the cursor catch up with this tag's position
  outputText(tagPos, skipBefore, closeParagraph)

  // Capture the text consumed by the tag
  var tagText = tagLen
    ? htmlspecialchars_noquotes(text.substr(tagPos, tagLen))
    : ''

  // Output current tag
  if (tag.isStartTag()) {
    // Handle paragraphs before opening the tag
    if (!HINT.RULE_BREAK_PARAGRAPH || !(tagFlags & RULE_BREAK_PARAGRAPH)) {
      outputParagraphStart(tagPos)
    }

    // Record this tag's namespace, if applicable
    if (HINT.namespaces) {
      var colonPos = tagName.indexOf(':')
      if (colonPos > 0) {
        namespaces[tagName.substr(0, colonPos)] = 0
      }
    }

    // Open the start tag and add its attributes, but don't close the tag
    output += '<' + tagName

    // We output the attributes in lexical order. Helps canonicalizing the output and could
    // prove useful someday
    var attributes = tag.getAttributes(),
      attributeNames = []
    for (var attrName in attributes) {
      attributeNames.push(attrName)
    }
    attributeNames.sort(function(a, b) {
      return a > b ? 1 : -1
    })
    attributeNames.forEach(function(attrName) {
      output +=
        ' ' +
        attrName +
        '="' +
        htmlspecialchars_compat(attributes[attrName].toString()).replace(
          /\n/g,
          '&#10;',
        ) +
        '"'
    })

    if (tag.isSelfClosingTag()) {
      if (tagLen) {
        output += '>' + tagText + '</' + tagName + '>'
      } else {
        output += '/>'
      }
    } else if (tagLen) {
      output += '><s>' + tagText + '</s>'
    } else {
      output += '>'
    }
  } else {
    if (tagLen) {
      output += '<e>' + tagText + '</e>'
    }

    output += '</' + tagName + '>'
  }

  // Move the cursor past the tag
  pos = tagPos + tagLen

  // Skip newlines (no other whitespace) after this tag
  wsPos = pos
  while (skipAfter && wsPos < textLen && text[wsPos] === '\n') {
    // Decrement the number of lines to skip
    --skipAfter

    // Move the cursor past the newline
    ++wsPos
  }
}

/**
 * Output the text between the cursor's position (included) and given position (not included)
 *
 * @param  {number}  catchupPos     Position we're catching up to
 * @param  {number}  maxLines       Maximum number of lines to ignore at the end of the text
 * @param  {boolean} closeParagraph Whether to close the paragraph at the end, if applicable
 */
function outputText(catchupPos, maxLines, closeParagraph) {
  if (closeParagraph) {
    if (!(context.flags & RULE_CREATE_PARAGRAPHS)) {
      closeParagraph = false
    } else {
      // Ignore any number of lines at the end if we're closing a paragraph
      maxLines = -1
    }
  }

  if (pos >= catchupPos) {
    // We're already there, close the paragraph if applicable and return
    if (closeParagraph) {
      outputParagraphEnd()
    }
  }

  // Skip over previously identified whitespace if applicable
  if (wsPos > pos) {
    var skipPos = Math.min(catchupPos, wsPos)
    output += text.substr(pos, skipPos - pos)
    pos = skipPos

    if (pos >= catchupPos) {
      // Skipped everything. Close the paragraph if applicable and return
      if (closeParagraph) {
        outputParagraphEnd()
      }
    }
  }

  var catchupLen, catchupText

  // Test whether we're even supposed to output anything
  if (HINT.RULE_IGNORE_TEXT && context.flags & RULE_IGNORE_TEXT) {
    ;(catchupLen = catchupPos - pos),
      (catchupText = text.substr(pos, catchupLen))

    // If the catchup text is not entirely composed of whitespace, we put it inside ignore tags
    if (!/^[ \n\t]*$/.test(catchupText)) {
      catchupText = '<i>' + htmlspecialchars_noquotes(catchupText) + '</i>'
    }

    output += catchupText
    pos = catchupPos

    if (closeParagraph) {
      outputParagraphEnd()
    }

    return
  }

  // Compute the amount of text to ignore at the end of the output
  var ignorePos = catchupPos,
    ignoreLen = 0

  // Ignore as many lines (including whitespace) as specified
  while (maxLines && --ignorePos >= pos) {
    var c = text[ignorePos]
    if (c !== ' ' && c !== '\n' && c !== '\t') {
      break
    }

    if (c === '\n') {
      --maxLines
    }

    ++ignoreLen
  }

  // Adjust catchupPos to ignore the text at the end
  catchupPos -= ignoreLen

  // Break down the text in paragraphs if applicable
  if (HINT.RULE_CREATE_PARAGRAPHS && context.flags & RULE_CREATE_PARAGRAPHS) {
    if (!context.inParagraph) {
      outputWhitespace(catchupPos)

      if (catchupPos > pos) {
        outputParagraphStart(catchupPos)
      }
    }

    // Look for a paragraph break in this text
    var pbPos = text.indexOf('\n\n', pos)

    while (pbPos > -1 && pbPos < catchupPos) {
      outputText(pbPos, 0, true)
      outputParagraphStart(catchupPos)

      pbPos = text.indexOf('\n\n', pos)
    }
  }

  // Capture, escape and output the text
  if (catchupPos > pos) {
    catchupText = htmlspecialchars_noquotes(text.substr(pos, catchupPos - pos))

    // Format line breaks if applicable
    if (
      HINT.RULE_ENABLE_AUTO_BR &&
      (context.flags & RULES_AUTO_LINEBREAKS) === RULE_ENABLE_AUTO_BR
    ) {
      catchupText = catchupText.replace(/\n/g, '<br/>\n')
    }

    output += catchupText
  }

  // Close the paragraph if applicable
  if (closeParagraph) {
    outputParagraphEnd()
  }

  // Add the ignored text if applicable
  if (ignoreLen) {
    output += text.substr(catchupPos, ignoreLen)
  }

  // Move the cursor past the text
  pos = catchupPos + ignoreLen
}

/**
 * Output a linebreak tag
 *
 * @param {!Tag} tag
 */
function outputBrTag(tag) {
  outputText(tag.getPos(), 0, false)
  output += '<br/>'
}

/**
 * Output an ignore tag
 *
 * @param {!Tag} tag
 */
function outputIgnoreTag(tag) {
  var tagPos = tag.getPos(),
    tagLen = tag.getLen()

  // Capture the text to ignore
  var ignoreText = text.substr(tagPos, tagLen)

  // Catch up with the tag's position then output the tag
  outputText(tagPos, 0, false)
  output += '<i>' + htmlspecialchars_noquotes(ignoreText) + '</i>'
  isRich = true

  // Move the cursor past this tag
  pos = tagPos + tagLen
}

/**
 * Start a paragraph between current position and given position, if applicable
 *
 * @param  {number} maxPos Rightmost position at which the paragraph can be opened
 */
function outputParagraphStart(maxPos) {
  if (!HINT.RULE_CREATE_PARAGRAPHS) {
    return
  }

  // Do nothing if we're already in a paragraph, or if we don't use paragraphs
  if (context.inParagraph || !(context.flags & RULE_CREATE_PARAGRAPHS)) {
    return
  }

  // Output the whitespace between pos and maxPos if applicable
  outputWhitespace(maxPos)

  // Open the paragraph, but only if it's not at the very end of the text
  if (pos < textLen) {
    output += '<p>'
    context.inParagraph = true
  }
}

/**
 * Close current paragraph at current position if applicable
 */
function outputParagraphEnd() {
  // Do nothing if we're not in a paragraph
  if (!context.inParagraph) {
    return
  }

  output += '</p>'
  context.inParagraph = false
}

/**
 * Output the content of a verbatim tag
 *
 * @param {!Tag} tag
 */
function outputVerbatim(tag) {
  var flags = context.flags
  context.flags = tag.getFlags()
  outputText(currentTag.getPos() + currentTag.getLen(), 0, false)
  context.flags = flags
}

/**
 * Skip as much whitespace after current position as possible
 *
 * @param  {number} maxPos Rightmost character to be skipped
 */
function outputWhitespace(maxPos) {
  while (pos < maxPos && ' \n\t'.indexOf(text[pos]) > -1) {
    output += text[pos]
    ++pos
  }
}

//==========================================================================
// Plugins handling
//==========================================================================

/**
 * Disable a plugin
 *
 * @param {string} pluginName Name of the plugin
 */
function disablePlugin(pluginName) {
  if (plugins[pluginName]) {
    plugins[pluginName].isDisabled = true
  }
}

/**
 * Enable a plugin
 *
 * @param {string} pluginName Name of the plugin
 */
function enablePlugin(pluginName) {
  if (plugins[pluginName]) {
    plugins[pluginName].isDisabled = false
  }
}

/**
 * Execute given plugin
 *
 * @param {string} pluginName Plugin's name
 */
function executePluginParser(pluginName) {
  var pluginConfig = plugins[pluginName]
  if (pluginConfig.quickMatch && text.indexOf(pluginConfig.quickMatch) < 0) {
    return
  }

  var matches = []
  if (
    HINT.regexp &&
    HINT.regexpLimit &&
    typeof pluginConfig.regexp !== 'undefined' &&
    typeof pluginConfig.regexpLimit !== 'undefined'
  ) {
    matches = getMatches(pluginConfig.regexp, pluginConfig.regexpLimit)
    if (!matches.length) {
      return
    }
  }

  // Execute the plugin's parser, which will add tags via addStartTag() and others
  getPluginParser(pluginName)(text, matches)
}

/**
 * Execute all the plugins
 */
function executePluginParsers() {
  for (var pluginName in plugins) {
    if (!plugins[pluginName].isDisabled) {
      executePluginParser(pluginName)
    }
  }
}

/**
 * Get regexp matches in a manner similar to preg_match_all() with PREG_SET_ORDER | PREG_OFFSET_CAPTURE
 *
 * @param  {!RegExp} regexp
 * @param  {number}  limit
 * @return {!Array.<!Array>}
 */
function getMatches(regexp, limit) {
  // Reset the regexp
  regexp.lastIndex = 0
  var matches = [],
    cnt = 0,
    m
  while (++cnt <= limit && (m = regexp.exec(text))) {
    // NOTE: coercing m.index to a number because Closure Compiler thinks pos is a string otherwise
    var pos = m.index,
      match = [[m[0], pos]],
      i = 0
    while (++i < m.length) {
      var str = m[i]

      // Sub-expressions that were not evaluated return undefined
      if (str === undefined) {
        match.push(['', -1])
      } else {
        match.push([str, text.indexOf(str, pos)])
        pos += str.length
      }
    }

    matches.push(match)
  }

  return matches
}

/**
 * Get the callback for given plugin's parser
 *
 * @param  {string} pluginName
 * @return {function(string, !Array)}
 */
function getPluginParser(pluginName) {
  return plugins[pluginName].parser
}

/**
 * Register a parser
 *
 * Can be used to add a new parser with no plugin config, or pre-generate a parser for an
 * existing plugin
 *
 * @param  {string}    pluginName
 * @param  {!Function} parser
 * @param  {?RegExp=}  regexp
 * @param  {number=}   limit
 */
function registerParser(pluginName, parser, regexp, limit) {
  // Create an empty config for this plugin to ensure it is executed
  if (!plugins[pluginName]) {
    plugins[pluginName] = {}
  }
  if (regexp) {
    plugins[pluginName].regexp = regexp
    plugins[pluginName].limit = limit || Infinity
  }
  plugins[pluginName].parser = parser
}

//==========================================================================
// Rules handling
//==========================================================================

/**
 * Apply closeAncestor rules associated with given tag
 *
 * @param  {!Tag}    tag Tag
 * @return {boolean}     Whether a new tag has been added
 */
function closeAncestor(tag) {
  if (!HINT.closeAncestor) {
    return false
  }

  if (openTags.length) {
    var tagName = tag.getName(),
      tagConfig = tagsConfig[tagName]

    if (tagConfig.rules.closeAncestor) {
      var i = openTags.length

      while (--i >= 0) {
        var ancestor = openTags[i],
          ancestorName = ancestor.getName()

        if (tagConfig.rules.closeAncestor[ancestorName]) {
          ++currentFixingCost

          // We have to close this ancestor. First we reinsert this tag...
          tagStack.push(tag)

          // ...then we add a new end tag for it with a better priority
          addMagicEndTag(ancestor, tag.getPos(), tag.getSortPriority() - 1)

          return true
        }
      }
    }
  }

  return false
}

/**
 * Apply closeParent rules associated with given tag
 *
 * @param  {!Tag}    tag Tag
 * @return {boolean}     Whether a new tag has been added
 */
function closeParent(tag) {
  if (!HINT.closeParent) {
    return false
  }

  if (openTags.length) {
    var tagName = tag.getName(),
      tagConfig = tagsConfig[tagName]

    if (tagConfig.rules.closeParent) {
      var parent = openTags[openTags.length - 1],
        parentName = parent.getName()

      if (tagConfig.rules.closeParent[parentName]) {
        ++currentFixingCost

        // We have to close that parent. First we reinsert the tag...
        tagStack.push(tag)

        // ...then we add a new end tag for it with a better priority
        addMagicEndTag(parent, tag.getPos(), tag.getSortPriority() - 1)

        return true
      }
    }
  }

  return false
}

/**
 * Apply the createChild rules associated with given tag
 *
 * @param {!Tag} tag Tag
 */
function createChild(tag) {
  if (!HINT.createChild) {
    return
  }

  var tagConfig = tagsConfig[tag.getName()]
  if (tagConfig.rules.createChild) {
    var priority = -1000,
      _text = text.substr(pos),
      tagPos = pos + _text.length - _text.replace(/^[ \n\r\t]+/, '').length
    tagConfig.rules.createChild.forEach(function(tagName) {
      addStartTag(tagName, tagPos, 0, ++priority)
    })
  }
}

/**
 * Apply fosterParent rules associated with given tag
 *
 * NOTE: this rule has the potential for creating an unbounded loop, either if a tag tries to
 *       foster itself or two or more tags try to foster each other in a loop. We mitigate the
 *       risk by preventing a tag from creating a child of itself (the parent still gets closed)
 *       and by checking and increasing the currentFixingCost so that a loop of multiple tags
 *       do not run indefinitely. The default tagLimit and nestingLimit also serve to prevent the
 *       loop from running indefinitely
 *
 * @param  {!Tag}    tag Tag
 * @return {boolean}     Whether a new tag has been added
 */
function fosterParent(tag) {
  if (!HINT.fosterParent) {
    return false
  }

  if (openTags.length) {
    var tagName = tag.getName(),
      tagConfig = tagsConfig[tagName]

    if (tagConfig.rules.fosterParent) {
      var parent = openTags[openTags.length - 1],
        parentName = parent.getName()

      if (tagConfig.rules.fosterParent[parentName]) {
        if (parentName !== tagName && currentFixingCost < maxFixingCost) {
          addFosterTag(tag, parent)
        }

        // Reinsert current tag
        tagStack.push(tag)

        // And finally close its parent with a priority that ensures it is processed
        // before this tag
        addMagicEndTag(parent, tag.getPos(), tag.getSortPriority() - 1)

        // Adjust the fixing cost to account for the additional tags/processing
        currentFixingCost += 4

        return true
      }
    }
  }

  return false
}

/**
 * Apply requireAncestor rules associated with given tag
 *
 * @param  {!Tag}    tag Tag
 * @return {boolean}     Whether this tag has an unfulfilled requireAncestor requirement
 */
function requireAncestor(tag) {
  if (!HINT.requireAncestor) {
    return false
  }

  var tagName = tag.getName(),
    tagConfig = tagsConfig[tagName]

  if (tagConfig.rules.requireAncestor) {
    var i = tagConfig.rules.requireAncestor.length
    while (--i >= 0) {
      var ancestorName = tagConfig.rules.requireAncestor[i]
      if (cntOpen[ancestorName]) {
        return false
      }
    }

    logger.err('Tag requires an ancestor', {
      requireAncestor: tagConfig.rules.requireAncestor.join(', '),
      tag: tag,
    })

    return true
  }

  return false
}

//==========================================================================
// Tag processing
//==========================================================================

/**
 * Create and add a copy of a tag as a child of a given tag
 *
 * @param {!Tag} tag       Current tag
 * @param {!Tag} fosterTag Tag to foster
 */
function addFosterTag(tag, fosterTag) {
  var coords = getMagicStartCoords(tag.getPos() + tag.getLen()),
    childPos = coords[0],
    childPrio = coords[1]

  // Add a 0-width copy of the parent tag after this tag and make it depend on this tag
  var childTag = addCopyTag(fosterTag, childPos, 0, childPrio)
  tag.cascadeInvalidationTo(childTag)
}

/**
 * Create and add an end tag for given start tag at given position
 *
 * @param  {!Tag}    startTag Start tag
 * @param  {number}  tagPos   End tag's position (will be adjusted for whitespace if applicable)
 * @param  {number=} prio     End tag's priority
 * @return {!Tag}
 */
function addMagicEndTag(startTag, tagPos, prio) {
  var tagName = startTag.getName()

  // Adjust the end tag's position if whitespace is to be minimized
  if (
    HINT.RULE_IGNORE_WHITESPACE &&
    (currentTag.getFlags() | startTag.getFlags()) & RULE_IGNORE_WHITESPACE
  ) {
    tagPos = getMagicEndPos(tagPos)
  }

  // Add a 0-width end tag that is paired with the given start tag
  var endTag = addEndTag(tagName, tagPos, 0, prio || 0)
  endTag.pairWith(startTag)

  return endTag
}

/**
 * Compute the position of a magic end tag, adjusted for whitespace
 *
 * @param  {number} tagPos Rightmost possible position for the tag
 * @return {number}
 */
function getMagicEndPos(tagPos) {
  // Back up from given position to the cursor's position until we find a character that
  // is not whitespace
  while (tagPos > pos && WHITESPACE.indexOf(text[tagPos - 1]) > -1) {
    --tagPos
  }

  return tagPos
}

/**
 * Compute the position and priority of a magic start tag, adjusted for whitespace
 *
 * @param  {number} tagPos Leftmost possible position for the tag
 * @return {!Array}        [Tag pos, priority]
 */
function getMagicStartCoords(tagPos) {
  var nextPos, nextPrio, nextTag, prio
  if (!tagStack.length) {
    // Set the next position outside the text boundaries
    nextPos = textLen + 1
    nextPrio = 0
  } else {
    nextTag = tagStack[tagStack.length - 1]
    nextPos = nextTag.getPos()
    nextPrio = nextTag.getSortPriority()
  }

  // Find the first non-whitespace position before next tag or the end of text
  while (tagPos < nextPos && WHITESPACE.indexOf(text[tagPos]) > -1) {
    ++tagPos
  }

  // Set a priority that ensures this tag appears before the next tag
  prio = tagPos === nextPos ? nextPrio - 1 : 0

  return [tagPos, prio]
}

/**
 * Test whether given start tag is immediately followed by a closing tag
 *
 * @param  {!Tag} tag Start tag (including self-closing)
 * @return {boolean}
 */
function isFollowedByClosingTag(tag) {
  return !tagStack.length ? false : tagStack[tagStack.length - 1].canClose(tag)
}

/**
 * Process all tags in the stack
 */
function processTags() {
  if (!tagStack.length) {
    return
  }

  // Initialize the count tables
  for (var tagName in tagsConfig) {
    cntOpen[tagName] = 0
    cntTotal[tagName] = 0
  }

  // Process the tag stack, close tags that were left open and repeat until done
  do {
    while (tagStack.length) {
      if (!tagStackIsSorted) {
        sortTags()
      }

      currentTag = tagStack.pop()
      processCurrentTag()
    }

    // Close tags that were left open
    openTags.forEach(function(startTag) {
      // NOTE: we add tags in hierarchical order (ancestors to descendants) but since
      //       the stack is processed in LIFO order, it means that tags get closed in
      //       the correct order, from descendants to ancestors
      addMagicEndTag(startTag, textLen)
    })
  } while (tagStack.length)
}

/**
 * Process current tag
 */
function processCurrentTag() {
  // Invalidate current tag if tags are disabled and current tag would not close the last open
  // tag and is not a system tag
  if (
    context.flags & RULE_IGNORE_TAGS &&
    !currentTag.canClose(openTags[openTags.length - 1]) &&
    !currentTag.isSystemTag()
  ) {
    currentTag.invalidate()
  }

  var tagPos = currentTag.getPos(),
    tagLen = currentTag.getLen()

  // Test whether the cursor passed this tag's position already
  if (pos > tagPos && !currentTag.isInvalid()) {
    // Test whether this tag is paired with a start tag and this tag is still open
    var startTag = currentTag.getStartTag()

    if (startTag && openTags.indexOf(startTag) >= 0) {
      // Create an end tag that matches current tag's start tag, which consumes as much of
      // the same text as current tag and is paired with the same start tag
      addEndTag(
        startTag.getName(),
        pos,
        Math.max(0, tagPos + tagLen - pos),
      ).pairWith(startTag)

      // Note that current tag is not invalidated, it's merely replaced
      return
    }

    // If this is an ignore tag, try to ignore as much as the remaining text as possible
    if (currentTag.isIgnoreTag()) {
      var ignoreLen = tagPos + tagLen - pos

      if (ignoreLen > 0) {
        // Create a new ignore tag and move on
        addIgnoreTag(pos, ignoreLen)

        return
      }
    }

    // Skipped tags are invalidated
    currentTag.invalidate()
  }

  if (currentTag.isInvalid()) {
    return
  }

  if (currentTag.isIgnoreTag()) {
    outputIgnoreTag(currentTag)
  } else if (currentTag.isBrTag()) {
    // Output the tag if it's allowed, ignore it otherwise
    if (!HINT.RULE_PREVENT_BR || !(context.flags & RULE_PREVENT_BR)) {
      outputBrTag(currentTag)
    }
  } else if (currentTag.isParagraphBreak()) {
    outputText(currentTag.getPos(), 0, true)
  } else if (currentTag.isVerbatim()) {
    outputVerbatim(currentTag)
  } else if (currentTag.isStartTag()) {
    processStartTag(currentTag)
  } else {
    processEndTag(currentTag)
  }
}

/**
 * Process given start tag (including self-closing tags) at current position
 *
 * @param {!Tag} tag Start tag (including self-closing)
 */
function processStartTag(tag) {
  var tagName = tag.getName(),
    tagConfig = tagsConfig[tagName]

  // 1. Check that this tag has not reached its global limit tagLimit
  // 2. Execute this tag's filterChain, which will filter/validate its attributes
  // 3. Apply closeParent, closeAncestor and fosterParent rules
  // 4. Check for nestingLimit
  // 5. Apply requireAncestor rules
  //
  // This order ensures that the tag is valid and within the set limits before we attempt to
  // close parents or ancestors. We need to close ancestors before we can check for nesting
  // limits, whether this tag is allowed within current context (the context may change
  // as ancestors are closed) or whether the required ancestors are still there (they might
  // have been closed by a rule.)
  if (cntTotal[tagName] >= tagConfig.tagLimit) {
    logger.err('Tag limit exceeded', {
      tag: tag,
      tagName: tagName,
      tagLimit: tagConfig.tagLimit,
    })
    tag.invalidate()

    return
  }

  filterTag(tag)
  if (tag.isInvalid()) {
    return
  }

  if (currentFixingCost < maxFixingCost) {
    if (fosterParent(tag) || closeParent(tag) || closeAncestor(tag)) {
      // This tag parent/ancestor needs to be closed, we just return (the tag is still valid)
      return
    }
  }

  if (cntOpen[tagName] >= tagConfig.nestingLimit) {
    logger.err('Nesting limit exceeded', {
      tag: tag,
      tagName: tagName,
      nestingLimit: tagConfig.nestingLimit,
    })
    tag.invalidate()

    return
  }

  if (!tagIsAllowed(tagName)) {
    var msg = 'Tag is not allowed in this context',
      context = { tag: tag, tagName: tagName }
    if (tag.getLen() > 0) {
      logger.warn(msg, context)
    } else {
      logger.debug(msg, context)
    }
    tag.invalidate()

    return
  }

  if (requireAncestor(tag)) {
    tag.invalidate()

    return
  }

  // If this tag has an autoClose rule and it's not self-closed, paired with an end tag, or
  // immediately followed by an end tag, we replace it with a self-closing tag with the same
  // properties
  if (
    HINT.RULE_AUTO_CLOSE &&
    tag.getFlags() & RULE_AUTO_CLOSE &&
    !tag.isSelfClosingTag() &&
    !tag.getEndTag() &&
    !isFollowedByClosingTag(tag)
  ) {
    var newTag = new Tag(
      Tag.SELF_CLOSING_TAG,
      tagName,
      tag.getPos(),
      tag.getLen(),
    )
    newTag.setAttributes(tag.getAttributes())
    newTag.setFlags(tag.getFlags())

    tag = newTag
  }

  if (
    HINT.RULE_TRIM_FIRST_LINE &&
    tag.getFlags() & RULE_TRIM_FIRST_LINE &&
    text[tag.getPos() + tag.getLen()] === '\n'
  ) {
    addIgnoreTag(tag.getPos() + tag.getLen(), 1)
  }

  // This tag is valid, output it and update the context
  outputTag(tag)
  pushContext(tag)

  // Apply the createChild rules if applicable
  createChild(tag)
}

/**
 * Process given end tag at current position
 *
 * @param {!Tag} tag End tag
 */
function processEndTag(tag) {
  var tagName = tag.getName()

  if (!cntOpen[tagName]) {
    // This is an end tag with no start tag
    return
  }

  /**
   * @type {!Array.<!Tag>} List of tags need to be closed before given tag
   */
  var closeTags = []

  // Iterate through all open tags from last to first to find a match for our tag
  var i = openTags.length
  while (--i >= 0) {
    var openTag = openTags[i]

    if (tag.canClose(openTag)) {
      break
    }

    closeTags.push(openTag)
    ++currentFixingCost
  }

  if (i < 0) {
    // Did not find a matching tag
    logger.debug('Skipping end tag with no start tag', { tag: tag })

    return
  }

  // Accumulate flags to determine whether whitespace should be trimmed
  var flags = tag.getFlags()
  closeTags.forEach(function(openTag) {
    flags |= openTag.getFlags()
  })
  var ignoreWhitespace =
    HINT.RULE_IGNORE_WHITESPACE && flags & RULE_IGNORE_WHITESPACE

  // Only reopen tags if we haven't exceeded our "fixing" budget
  var keepReopening =
      HINT.RULE_AUTO_REOPEN && currentFixingCost < maxFixingCost,
    reopenTags = []
  closeTags.forEach(function(openTag) {
    var openTagName = openTag.getName()

    // Test whether this tag should be reopened automatically
    if (keepReopening) {
      if (openTag.getFlags() & RULE_AUTO_REOPEN) {
        reopenTags.push(openTag)
      } else {
        keepReopening = false
      }
    }

    // Find the earliest position we can close this open tag
    var tagPos = tag.getPos()
    if (ignoreWhitespace) {
      tagPos = getMagicEndPos(tagPos)
    }

    // Output an end tag to close this start tag, then update the context
    var endTag = new Tag(Tag.END_TAG, openTagName, tagPos, 0)
    endTag.setFlags(openTag.getFlags())
    outputTag(endTag)
    popContext()
  })

  // Output our tag, moving the cursor past it, then update the context
  outputTag(tag)
  popContext()

  // If our fixing budget allows it, peek at upcoming tags and remove end tags that would
  // close tags that are already being closed now. Also, filter our list of tags being
  // reopened by removing those that would immediately be closed
  if (closeTags.length && currentFixingCost < maxFixingCost) {
    /**
     * @type {number} Rightmost position of the portion of text to ignore
     */
    var ignorePos = pos

    i = tagStack.length
    while (--i >= 0 && ++currentFixingCost < maxFixingCost) {
      var upcomingTag = tagStack[i]

      // Test whether the upcoming tag is positioned at current "ignore" position and it's
      // strictly an end tag (not a start tag or a self-closing tag)
      if (upcomingTag.getPos() > ignorePos || upcomingTag.isStartTag()) {
        break
      }

      // Test whether this tag would close any of the tags we're about to reopen
      var j = closeTags.length

      while (--j >= 0 && ++currentFixingCost < maxFixingCost) {
        if (upcomingTag.canClose(closeTags[j])) {
          // Remove the tag from the lists and reset the keys
          closeTags.splice(j, 1)

          if (reopenTags[j]) {
            reopenTags.splice(j, 1)
          }

          // Extend the ignored text to cover this tag
          ignorePos = Math.max(
            ignorePos,
            upcomingTag.getPos() + upcomingTag.getLen(),
          )

          break
        }
      }
    }

    if (ignorePos > pos) {
      /**
       * @todo have a method that takes (pos,len) rather than a Tag
       */
      outputIgnoreTag(new Tag(Tag.SELF_CLOSING_TAG, 'i', pos, ignorePos - pos))
    }
  }

  // Re-add tags that need to be reopened, at current cursor position
  reopenTags.forEach(function(startTag) {
    var newTag = addCopyTag(startTag, pos, 0)

    // Re-pair the new tag
    var endTag = startTag.getEndTag()
    if (endTag) {
      newTag.pairWith(endTag)
    }
  })
}

/**
 * Update counters and replace current context with its parent context
 */
function popContext() {
  var tag = openTags.pop()
  --cntOpen[tag.getName()]
  context = context.parentContext
}

/**
 * Update counters and replace current context with a new context based on given tag
 *
 * If given tag is a self-closing tag, the context won't change
 *
 * @param {!Tag} tag Start tag (including self-closing)
 */
function pushContext(tag) {
  var tagName = tag.getName(),
    tagFlags = tag.getFlags(),
    tagConfig = tagsConfig[tagName]

  ++cntTotal[tagName]

  // If this is a self-closing tag, the context remains the same
  if (tag.isSelfClosingTag()) {
    return
  }

  // Recompute the allowed tags
  var allowed = []
  context.allowed.forEach(function(v, k) {
    // If the current tag is not transparent, override the low bits (allowed children) of
    // current context with its high bits (allowed descendants)
    if (!HINT.RULE_IS_TRANSPARENT || !(tagFlags & RULE_IS_TRANSPARENT)) {
      v = (v & 0xff00) | (v >> 8)
    }
    allowed.push(tagConfig.allowed[k] & v)
  })

  // Use this tag's flags as a base for this context and add inherited rules
  var flags = tagFlags | (context.flags & RULES_INHERITANCE)

  // RULE_DISABLE_AUTO_BR turns off RULE_ENABLE_AUTO_BR
  if (flags & RULE_DISABLE_AUTO_BR) {
    flags &= ~RULE_ENABLE_AUTO_BR
  }

  ++cntOpen[tagName]
  openTags.push(tag)
  context = { parentContext: context }
  context.allowed = allowed
  context.flags = flags
}

/**
 * Return whether given tag is allowed in current context
 *
 * @param  {string}  tagName
 * @return {boolean}
 */
function tagIsAllowed(tagName) {
  var n = tagsConfig[tagName].bitNumber

  return !!(context.allowed[n >> 3] & (1 << (n & 7)))
}

//==========================================================================
// Tag stack
//==========================================================================

/**
 * Add a start tag
 *
 * @param  {string}  name Name of the tag
 * @param  {number}  pos  Position of the tag in the text
 * @param  {number}  len  Length of text consumed by the tag
 * @param  {number=} prio Tags' priority
 * @return {!Tag}
 */
function addStartTag(name, pos, len, prio) {
  return addTag(Tag.START_TAG, name, pos, len, prio || 0)
}

/**
 * Add an end tag
 *
 * @param  {string}  name Name of the tag
 * @param  {number}  pos  Position of the tag in the text
 * @param  {number}  len  Length of text consumed by the tag
 * @param  {number=} prio Tags' priority
 * @return {!Tag}
 */
function addEndTag(name, pos, len, prio) {
  return addTag(Tag.END_TAG, name, pos, len, prio || 0)
}

/**
 * Add a self-closing tag
 *
 * @param  {string}  name Name of the tag
 * @param  {number}  pos  Position of the tag in the text
 * @param  {number}  len  Length of text consumed by the tag
 * @param  {number=} prio Tags' priority
 * @return {!Tag}
 */
function addSelfClosingTag(name, pos, len, prio) {
  return addTag(Tag.SELF_CLOSING_TAG, name, pos, len, prio || 0)
}

/**
 * Add a 0-width "br" tag to force a line break at given position
 *
 * @param  {number}  pos  Position of the tag in the text
 * @param  {number=} prio Tags' priority
 * @return {!Tag}
 */
function addBrTag(pos, prio) {
  return addTag(Tag.SELF_CLOSING_TAG, 'br', pos, 0, prio || 0)
}

/**
 * Add an "ignore" tag
 *
 * @param  {number}  pos  Position of the tag in the text
 * @param  {number}  len  Length of text consumed by the tag
 * @param  {number=} prio Tags' priority
 * @return {!Tag}
 */
function addIgnoreTag(pos, len, prio) {
  return addTag(
    Tag.SELF_CLOSING_TAG,
    'i',
    pos,
    Math.min(len, textLen - pos),
    prio || 0,
  )
}

/**
 * Add a paragraph break at given position
 *
 * Uses a zero-width tag that is actually never output in the result
 *
 * @param  {number}  pos  Position of the tag in the text
 * @param  {number=} prio Tags' priority
 * @return {!Tag}
 */
function addParagraphBreak(pos, prio) {
  return addTag(Tag.SELF_CLOSING_TAG, 'pb', pos, 0, prio || 0)
}

/**
 * Add a copy of given tag at given position and length
 *
 * @param  {!Tag}    tag  Original tag
 * @param  {number}  pos  Copy's position
 * @param  {number}  len  Copy's length
 * @param  {number=} prio Tags' priority
 * @return {!Tag}         Copy tag
 */
function addCopyTag(tag, pos, len, prio) {
  var copy = addTag(
    tag.getType(),
    tag.getName(),
    pos,
    len,
    tag.getSortPriority(),
  )
  copy.setAttributes(tag.getAttributes())

  return copy
}

/**
 * Add a tag
 *
 * @param  {number}  type Tag's type
 * @param  {string}  name Name of the tag
 * @param  {number}  pos  Position of the tag in the text
 * @param  {number}  len  Length of text consumed by the tag
 * @param  {number=} prio Tags' priority
 * @return {!Tag}
 */
function addTag(type, name, pos, len, prio) {
  // Create the tag
  var tag = new Tag(type, name, pos, len, prio || 0)

  // Set this tag's rules bitfield
  if (tagsConfig[name]) {
    tag.setFlags(tagsConfig[name].rules.flags)
  }

  // Invalidate this tag if it's an unknown tag, a disabled tag, if either of its length or
  // position is negative or if it's out of bounds
  if (
    (!tagsConfig[name] && !tag.isSystemTag()) ||
    isInvalidTextSpan(pos, len)
  ) {
    tag.invalidate()
  } else if (tagsConfig[name] && tagsConfig[name].isDisabled) {
    logger.warn('Tag is disabled', {
      tag: tag,
      tagName: name,
    })
    tag.invalidate()
  } else {
    insertTag(tag)
  }

  return tag
}

/**
 * Test whether given text span is outside text boundaries or an invalid UTF sequence
 *
 * @param  {number}  pos Start of text
 * @param  {number}  len Length of text
 * @return {boolean}
 */
function isInvalidTextSpan(pos, len) {
  return (
    len < 0 ||
    pos < 0 ||
    pos + len > textLen ||
    /[\uDC00-\uDFFF]/.test(text.substr(pos, 1) + text.substr(pos + len, 1))
  )
}

/**
 * Insert given tag in the tag stack
 *
 * @param {!Tag} tag
 */
function insertTag(tag) {
  if (!tagStackIsSorted) {
    tagStack.push(tag)
  } else {
    // Scan the stack and copy every tag to the next slot until we find the correct index
    var i = tagStack.length,
      key = getSortKey(tag)
    while (i > 0 && key > getSortKey(tagStack[i - 1])) {
      tagStack[i] = tagStack[i - 1]
      --i
    }
    tagStack[i] = tag
  }
}

/**
 * Add a pair of tags
 *
 * @param  {string} name     Name of the tags
 * @param  {number} startPos Position of the start tag
 * @param  {number} startLen Length of the start tag
 * @param  {number} endPos   Position of the start tag
 * @param  {number} endLen   Length of the start tag
 * @param  {number=}  prio     Start tag's priority (the end tag will be set to minus that value)
 * @return {!Tag}             Start tag
 */
function addTagPair(name, startPos, startLen, endPos, endLen, prio) {
  // NOTE: the end tag is added first to try to keep the stack in the correct order
  var endTag = addEndTag(name, endPos, endLen, -prio || 0),
    startTag = addStartTag(name, startPos, startLen, prio || 0)
  startTag.pairWith(endTag)

  return startTag
}

/**
 * Add a tag that represents a verbatim copy of the original text
 *
 * @param  {number} pos  Position of the tag in the text
 * @param  {number} len  Length of text consumed by the tag
 * @param  {number=} prio Tag's priority
 * @return {!Tag}
 */
function addVerbatim(pos, len, prio) {
  return addTag(Tag.SELF_CLOSING_TAG, 'v', pos, len, prio || 0)
}

/**
 * Sort tags by position and precedence
 */
function sortTags() {
  var arr = {},
    keys = [],
    i = tagStack.length
  while (--i >= 0) {
    var tag = tagStack[i],
      key = getSortKey(tag, i)
    keys.push(key)
    arr[key] = tag
  }
  keys.sort()

  i = keys.length
  tagStack = []
  while (--i >= 0) {
    tagStack.push(arr[keys[i]])
  }

  tagStackIsSorted = true
}

/**
 * Generate a key for given tag that can be used to compare its position using lexical comparisons
 *
 * Tags are sorted by position first, then by priority, then by whether they consume any text,
 * then by length, and finally in order of their creation.
 *
 * The stack's array is in reverse order. Therefore, tags that appear at the start of the text
 * are at the end of the array.
 *
 * @param  {!Tag}    tag
 * @param  {number=} tagIndex
 * @return {string}
 */
function getSortKey(tag, tagIndex) {
  // Ensure that negative values are sorted correctly by flagging them and making them positive
  var prioFlag = tag.getSortPriority() >= 0,
    prio = tag.getSortPriority()
  if (!prioFlag) {
    prio += 1 << 30
  }

  // Sort 0-width tags separately from the rest
  var lenFlag = tag.getLen() > 0,
    lenOrder
  if (lenFlag) {
    // Inverse their length so that longest matches are processed first
    lenOrder = textLen - tag.getLen()
  } else {
    // Sort self-closing tags in-between start tags and end tags to keep them outside of tag
    // pairs
    var order = {}
    order[Tag.END_TAG] = 0
    order[Tag.SELF_CLOSING_TAG] = 1
    order[Tag.START_TAG] = 2
    lenOrder = order[tag.getType()]
  }

  return (
    hex32(tag.getPos()) +
    +prioFlag +
    hex32(prio) +
    +lenFlag +
    hex32(lenOrder) +
    hex32(tagIndex || 0)
  )
}

/**
 * Format given number to a 32 bit hex value
 *
 * @param  {number} number
 * @return {string}
 */
function hex32(number) {
  var hex = number.toString(16)

  return '        '.substr(hex.length) + hex
}
var MSXML =
  typeof DOMParser === 'undefined' || typeof XSLTProcessor === 'undefined'
var xslt = {
  /**
   * @param {string} xsl
   */
  init: function(xsl) {
    var stylesheet = xslt.loadXML(xsl)
    if (MSXML) {
      var generator = new ActiveXObject('MSXML2.XSLTemplate.6.0')
      generator['stylesheet'] = stylesheet
      xslt.proc = generator['createProcessor']()
    } else {
      xslt.proc = new XSLTProcessor()
      xslt.proc['importStylesheet'](stylesheet)
    }
  },

  /**
   * @param  {string} xml
   * @return {!Document}
   */
  loadXML: function(xml) {
    var dom
    if (MSXML) {
      dom = new ActiveXObject('MSXML2.FreeThreadedDOMDocument.6.0')
      dom['async'] = false
      dom['validateOnParse'] = false
      dom['loadXML'](xml)
    } else {
      dom = new DOMParser().parseFromString(xml, 'text/xml')
    }

    if (!dom) {
      throw 'Cannot parse ' + xml
    }

    return dom
  },

  /**
   * @param {string} paramName  Parameter name
   * @param {string} paramValue Parameter's value
   */
  setParameter: function(paramName, paramValue) {
    if (MSXML) {
      xslt.proc['addParameter'](paramName, paramValue, '')
    } else {
      xslt.proc['setParameter'](null, paramName, paramValue)
    }
  },

  /**
   * @param  {string}    xml
   * @param  {!Document} targetDoc
   * @return {!DocumentFragment}
   */
  transformToFragment: function(xml, targetDoc) {
    if (MSXML) {
      var div = targetDoc.createElement('div'),
        fragment = targetDoc.createDocumentFragment()

      xslt.proc['input'] = xslt.loadXML(xml)
      xslt.proc['transform']()
      div.innerHTML = xslt.proc['output']
      while (div.firstChild) {
        fragment.appendChild(div.firstChild)
      }

      return fragment
    }

    return xslt.proc['transformToFragment'](xslt.loadXML(xml), targetDoc)
  },
}
xslt.init(xsl)

var functionCache = {}

/**
 * Parse a given text and render it into given HTML element
 *
 * @param  {string} text
 * @param  {!HTMLElement} target
 * @return {!Node}
 */
function preview(text, target) {
  var targetDoc = target.ownerDocument
  if (!targetDoc) {
    throw 'Target does not have a ownerDocument'
  }

  var resultFragment = xslt.transformToFragment(
      parse(text).replace(/<[eis]>[^<]*<\/[eis]>/g, ''),
      targetDoc,
    ),
    lastUpdated = target

  // https://bugs.chromium.org/p/chromium/issues/detail?id=266305
  if (typeof window !== 'undefined' && 'chrome' in window) {
    resultFragment.querySelectorAll('script').forEach(function(oldScript) {
      let newScript = document.createElement('script')
      for (let attribute of oldScript['attributes']) {
        newScript['setAttribute'](attribute.name, attribute.value)
      }
      newScript.textContent = oldScript.textContent

      oldScript.parentNode.replaceChild(newScript, oldScript)
    })
  }

  // Compute and refresh hashes
  if (HINT.hash) {
    computeHashes(resultFragment)
  }

  // Apply post-processing
  if (HINT.onRender) {
    executeEvents(resultFragment, 'render')
  }

  /**
   * Compute and set all hashes in given document fragment
   *
   * @param {!DocumentFragment} fragment
   */
  function computeHashes(fragment) {
    var nodes = fragment.querySelectorAll('[data-s9e-livepreview-hash]'),
      i = nodes.length
    while (--i >= 0) {
      nodes[i]['setAttribute'](
        'data-s9e-livepreview-hash',
        hash(nodes[i].outerHTML),
      )
    }
  }

  /**
   * Execute an event's code on a given node
   *
   * @param {!Element} node
   * @param {string}   eventName
   */
  function executeEvent(node, eventName) {
    /** @type {string} */
    var code = node.getAttribute('data-s9e-livepreview-on' + eventName)
    if (!functionCache[code]) {
      functionCache[code] = new Function(code)
    }

    functionCache[code]['call'](node)
  }

  /**
   * Locate and execute an event on given document fragment or element
   *
   * @param {!DocumentFragment|!Element} root
   * @param {string}                     eventName
   */
  function executeEvents(root, eventName) {
    // Execute the event on the root node, as there is no self-or-descendant selector in CSS
    if (
      root instanceof Element &&
      root['hasAttribute']('data-s9e-livepreview-on' + eventName)
    ) {
      executeEvent(root, eventName)
    }

    var nodes = root.querySelectorAll(
        '[data-s9e-livepreview-on' + eventName + ']',
      ),
      i = nodes.length
    while (--i >= 0) {
      executeEvent(nodes[i], eventName)
    }
  }

  /**
   * Update the content of given node oldParent to match node newParent
   *
   * @param {!Node} oldParent
   * @param {!Node} newParent
   */
  function refreshElementContent(oldParent, newParent) {
    var oldNodes = oldParent.childNodes,
      newNodes = newParent.childNodes,
      oldCnt = oldNodes.length,
      newCnt = newNodes.length,
      oldNode,
      newNode,
      left = 0,
      right = 0

    // Skip the leftmost matching nodes
    while (left < oldCnt && left < newCnt) {
      oldNode = oldNodes[left]
      newNode = newNodes[left]
      if (!refreshNode(oldNode, newNode)) {
        break
      }

      ++left
    }

    // Skip the rightmost matching nodes
    var maxRight = Math.min(oldCnt - left, newCnt - left)
    while (right < maxRight) {
      oldNode = oldNodes[oldCnt - (right + 1)]
      newNode = newNodes[newCnt - (right + 1)]
      if (!refreshNode(oldNode, newNode)) {
        break
      }

      ++right
    }

    // Remove the old dirty nodes in the middle of the tree
    var i = oldCnt - right
    while (--i >= left) {
      oldParent.removeChild(oldNodes[i])
      lastUpdated = oldParent
    }

    // Test whether there are any nodes in the new tree between the matching nodes at the left
    // and the matching nodes at the right
    var rightBoundary = newCnt - right
    if (left >= rightBoundary) {
      return
    }

    // Clone the new nodes
    var newNodesFragment = targetDoc.createDocumentFragment()
    i = left
    do {
      newNode = newNodes[i]
      if (HINT.onUpdate && newNode instanceof Element) {
        executeEvents(newNode, 'update')
      }
      lastUpdated = newNodesFragment.appendChild(newNode)
    } while (i < --rightBoundary)

    // If we haven't skipped any nodes to the right, we can just append the fragment
    if (!right) {
      oldParent.appendChild(newNodesFragment)
    } else {
      oldParent.insertBefore(newNodesFragment, oldParent.childNodes[left])
    }
  }

  /**
   * Update given node oldNode to make it match newNode
   *
   * @param {!Node} oldNode
   * @param {!Node} newNode
   * @return {boolean} Whether the node can be skipped
   */
  function refreshNode(oldNode, newNode) {
    if (
      oldNode.nodeName !== newNode.nodeName ||
      oldNode.nodeType !== newNode.nodeType
    ) {
      return false
    }

    if (oldNode instanceof HTMLElement && newNode instanceof HTMLElement) {
      if (
        !oldNode.isEqualNode(newNode) &&
        !elementHashesMatch(oldNode, newNode)
      ) {
        if (
          HINT.onUpdate &&
          newNode['hasAttribute']('data-s9e-livepreview-onupdate')
        ) {
          executeEvent(newNode, 'update')
        }
        syncElementAttributes(oldNode, newNode)
        refreshElementContent(oldNode, newNode)
      }
    }
    // Node.TEXT_NODE || Node.COMMENT_NODE
    else if (oldNode.nodeType === 3 || oldNode.nodeType === 8) {
      if (oldNode.nodeValue !== newNode.nodeValue) {
        oldNode.nodeValue = newNode.nodeValue
        lastUpdated = oldNode
      }
    }

    return true
  }

  /**
   * Test whether both given elements have a hash value and both match
   *
   * @param  {!HTMLElement} oldEl
   * @param  {!HTMLElement} newEl
   * @return {boolean}
   */
  function elementHashesMatch(oldEl, newEl) {
    if (!HINT.hash) {
      // Hashes can never match if there are no hashes in any template
      return false
    }
    const attrName = 'data-s9e-livepreview-hash'

    return (
      oldEl['hasAttribute'](attrName) &&
      newEl['hasAttribute'](attrName) &&
      oldEl['getAttribute'](attrName) === newEl['getAttribute'](attrName)
    )
  }

  /**
   * Hash given string
   *
   * @param  {string} text
   * @return {number}
   */
  function hash(text) {
    var pos = text.length,
      s1 = 0,
      s2 = 0
    while (--pos >= 0) {
      s1 = (s1 + text.charCodeAt(pos)) % 0xffff
      s2 = (s1 + s2) % 0xffff
    }

    return (s2 << 16) | s1
  }

  /**
   * Make the set of attributes of given element oldEl match newEl's
   *
   * @param {!HTMLElement} oldEl
   * @param {!HTMLElement} newEl
   */
  function syncElementAttributes(oldEl, newEl) {
    var oldAttributes = oldEl['attributes'],
      newAttributes = newEl['attributes'],
      oldCnt = oldAttributes.length,
      newCnt = newAttributes.length,
      i = oldCnt,
      ignoreAttrs =
        ' ' + oldEl.getAttribute('data-s9e-livepreview-ignore-attrs') + ' '

    while (--i >= 0) {
      var oldAttr = oldAttributes[i],
        namespaceURI = oldAttr['namespaceURI'],
        attrName = oldAttr['name']

      if (HINT.ignoreAttrs && ignoreAttrs.indexOf(' ' + attrName + ' ') > -1) {
        continue
      }
      if (!newEl.hasAttributeNS(namespaceURI, attrName)) {
        oldEl.removeAttributeNS(namespaceURI, attrName)
        lastUpdated = oldEl
      }
    }

    i = newCnt
    while (--i >= 0) {
      var newAttr = newAttributes[i],
        namespaceURI = newAttr['namespaceURI'],
        attrName = newAttr['name'],
        attrValue = newAttr['value']

      if (HINT.ignoreAttrs && ignoreAttrs.indexOf(' ' + attrName + ' ') > -1) {
        continue
      }
      if (attrValue !== oldEl.getAttributeNS(namespaceURI, attrName)) {
        oldEl.setAttributeNS(namespaceURI, attrName, attrValue)
        lastUpdated = oldEl
      }
    }
  }

  refreshElementContent(target, resultFragment)

  return lastUpdated
}

/**
 * Set the value of a stylesheet parameter
 *
 * @param {string} paramName  Parameter name
 * @param {string} paramValue Parameter's value
 */
function setParameter(paramName, paramValue) {
  xslt.setParameter(paramName, paramValue)
}

export default {
  TextFormatter: { preview: preview },
}
